import ApplicationFormEditor from "./en/ApplicationFormEditor";

export const en = {
  translation: {
    close: "Close",
    download: "Download",
    cancel_modal_description: "Are you sure you want to discard the changes you made?",
    cancel_modal_description_physician_duplicate_redirect:
      "You will now be redirected to the selected physician. Are you sure you want to discard the changes you made?",
    popup_modal_description_prompt_message: "Are you sure you want to leave? All changes will be lost.",
    popup_modal_description_prompt_message_duplication:
      "Are you sure you want to leave? Duplicated claim will not be saved.",
    approve_discard: "Yes, Discard",
    required: "Required",
    required_message: "This is required",
    dashboard: "Home",
    search_results: "Search Results",
    recently_viewed_patients: "Recently Viewed Patients",
    type_to_search: "Type to search",
    searching: "Searching...",
    loading: "Loading...",
    financial_navigation: "Financial Navigation",
    prepare_new_enrollment: "Prepare New Enrollment",
    prepare_new_enrollment_second_button: "Prepare New",
    sign_out: "Sign Out",
    send: "Send",
    patients: "Patients",
    copy: "Copy",
    applications: "Applications",
    enrollments: "Enrollments",
    cancel: "Cancel",
    upload: "Upload",
    duplicate: "Duplicate",
    $0: "$ 0",
    save_changes: "Save changes",
    welcome: "Welcome",
    back: "Back",
    select_all: "Select All",
    environment_header: "This is a {{environment}} environment",
    demo_mode: "DEMO MODE",
    sortInfo: "Sort is only available for {{threshold}}K results or less",
    footer: "© {{year}} TailorMed. All rights reserved",
    main_title: "Good {{timeOfDay}}, {{firstName}}",
    main_subtitle: "Use advanced search and proactive worklists to remove financial barriers for your patients",
    pending_actions: {
      title: "Extra Care Opportunities",
      subtitle: "Help more patients save on their medications",
      patients_total: "patients total",
      m3p_eligible: {
        title: "M3P Eligible Patients",
        description: "Patients who may benefit from Medicare's Prescription Payment Plan",
        action: "Send M3P Invite"
      },
      express_enroll_invites_eligible: {
        title: "Patient Express Enroll (Self-Enroll)",
        description: "Patients eligible to self-enroll",
        action: "Send self-enroll link"
      },
      new_programs: {
        title: "New Eligible Programs",
        description: "Patients matched with new assistance programs",
        action_label: "Notify Patients"
      },
      pending_renewals: {
        title: "Pending Renewals",
        description: "Enrollments requiring renewal soon",
        action_label: "Send Reminders"
      },
      review_patients: "Review Patients",
      send_to_all: "Send to All",
      select_all: "Select All",
      selected_count: "{{count}} of {{total}} selected",
      search_patients: "Search patients...",
      no_patients_found: "No patients found matching your search",
      no_patients_available: "No patients available",
      patients_will_receive: "{{count}} patient will receive {{action}}",
      patients_will_receive_plural: "{{count}} patients will receive {{action}}",
      select_patients_to_proceed: "Select patients to proceed",
      empty_state: {
        title: "All caught up!",
        description: "No pending actions at the moment. We'll notify you when there are patients requiring attention."
      },
      drawer: {
        title: "Review Patients",
        subtitle: "Review relevant patients"
      },
      modal: {
        title: "Review Patients",
        subtitle: "Review relevant patients"
      },
      table: {
        patient: "Patient",
        drug: "Drug",
        insurance: "Insurance",
        eligibility_score: "Eligibility Score",
        program: "Program",
        program_type: "Type",
        renewal_date: "Renewal Date",
        status: "Status"
      },
      urgency: {
        urgent: "Urgent",
        soon: "Soon",
        on_track: "On Track"
      }
    },
    not_found: "Not found",
    alerts: "Alerts",
    login_email_support: "E-mail support",
    login_support: "For support, contact support@tailormed.co",
    support_email: "support@tailormed.co",
    email_to_support: "mailto:support@tailormed.co",
    uploader_secure_upload: "Secure Upload",
    additional_attachments: "Additional Attachments",
    uploader_form_title: "Click the browse button and select file to upload",
    uploader_form_browse: "Browse",
    uploader_form_file_size: "12MB per file",
    uploader_form_browse_more: "Add Another File",
    uploader_form_upload: "Upload",
    uploader_form_cancel: "Cancel",
    uploader_form_back: "Go Back",
    are_you_sure_you_want_to_proceed: " Are you sure you want to proceed?",
    all: "All",
    all_times: "All Times",
    this_week: "This Week",
    this_month: "This Month",
    last_3_days: "Last 3 Days",
    last_week: "Last Week",
    last_month: "Last Month",
    last_year: "Last Year",
    last_2_months: "Last 2 Months",
    last_3_months: "Last 3 Months",
    past_1_month: "Last Month",
    past_3_months: "Last 3 Months",
    past_12_months: "Last 12 Months",
    next_month: "Next Month",
    more_than_7_days: "More Than 7 Days",
    more_than_14_days: "More Than 14 Days",
    more_than_30_days: "More Than 30 Days",
    more_than_60_days: "More Than 60 Days",
    recent_insurance_changes: "Recent Insurance Changes",
    all_changes: "All Changes",
    plan_market_changes: "Plan Market Changes Only",
    plan_market_change: "Plan Market Change",
    change_type: "Change Type",
    timeframe: "Timeframe",
    show_changes_from: "Show Changes From",
    recent_insurance_change: "Recent Insurance Change",
    no_change: "N/A",
    became_insured: "Became Insured",
    became_uninsured: "Became Uninsured",
    become_uninsured: "Became Uninsured",
    other_changes: "Other Changes",
    consent_status: "Consent Status",
    consent_status_no_record: "No consent on file",
    consent_status_link_expired: "Request Link Expired",
    consent_status_pending_signature: "Pending Signature",
    consent_status_received: "Consent Received",
    consent_status_revoked: "Consent Revoked",
    consent_status_expired: "Consent Expired",
    next_3_days: "Next 3 Days",
    next_7_days: "Next 7 Days",
    next_30_days: "Next 30 Days",
    last_90_days: "Last 90 Days",
    next_2_days: "Next 2 Days",
    indefinitely: "Indefinitely",
    ok: "Ok",
    following_week: "Following Week",
    filter_by: "Filter By",
    today: "Today",
    mark_as_favorite: "Mark as Favorite",
    favorite: "Favorite",
    edit: "Edit",
    update: "Update",
    favorites: "Favorites",
    express_enroll_eligible: "Express Enroll Eligible",
    enroll: "Enroll",
    enroll_express_tooltip: "Express Enroll this patient",
    express_enroll_saved_list: "Express Enroll Saved List",
    hide_deceased_patients: "Hide Deceased Patients",
    awaiting_assistance: "Awaiting Assistance",
    done: "Done",
    follow_up: "Follow-Up",
    in_progress: "In Progress",
    archived: "Archived",
    oop_met: "OOP Met",
    save_as_new_list: "Save As New List",
    analysis_request: "Analysis Request",
    established: "Established",
    new: "New",
    individual: "Individual",
    large_employer: "Large Employer",
    medicare_advantage: "Medicare Advantage",
    medicare_part_d: "Medicare Part D",
    medigap: "Medigap",
    original_medicare: "Original Medicare",
    commercial: "Commercial",
    medicaid: "Medicaid",
    federal: "Federal",
    small_group: "Small Group",
    state: "State",
    state_expansion: "State Expansion",
    uncovered: "No Coverage",
    uninsured: "Uninsured",
    iv: "IV",
    non_iv: "Non-IV",
    infusion: "Infusion",
    subcutaneous: "Subcutaneous",
    oral_and_others: "Oral and Others",
    cancer: "Cancer",
    non_cancer: "Non-Cancer",
    active_treatment: "Active Treatment",
    popover_visit_schedule: "Patient’s visits in the selected timeframe:",
    active_treatment_tooltip:
      'Patients are considered in "active treatment" if they have a drug event in the last 6 months',
    express_enroll_eligibile_tooltip: "Patients matched to a supported Express Enroll copay program.",
    group_patients_visits: "Group Patients’ Visits",
    group_patients_visits_tooltip:
      "Groups all of the patient’s visits for the displayed time frame. Visits are shown according to the first visit date and time",
    filter_selected_plan_markets: "Only selected plan market(s)",
    filter_selected_plan_markets_tooltip:
      "Filters the list to show only patients whose plan market(s) match the selected options. Patients with other plan markets will be excluded.",
    foundation_copay_card: "Foundation Copay Card",
    foundation_copay: "Foundation Copay",
    foundation_premium: "Foundation Premium",
    manufacturer_copay: "Manufacturer Copay",
    manufacturer_pap_and_replacement: "Manufacturer PAP and Replacement",
    manufacturer_other: "Manufacturer Other",
    manufacturer_other_tooltip:
      "Filtering by Manufacturer Other includes: Manufacturer Quickstart, Manufacturer Trial, Manufacturer Bridge, Manufacturer Voucher, and Manufacturer Coupon or Rebate.",
    ancillary_living_expenses: "Ancillary/Living Expenses",
    support_program: "Support Program",
    government_plans: "Government Plan",
    discount: "Discount",
    free_drug: "Free Drug",
    dosage_amount: "Dosage Amount",
    government_plan: "Government Plan",
    copay_foundation: "Copay Foundation",
    living_and_transport_expenses: "Living and Transport Expenses",
    manufacturere_copay_card: "Manufacturer Copay Card",
    internal: "Internal",
    applied: "Applied",
    applied_to_waitlist: "Applied to Waitlist",
    approved: "Approved",
    canceled: "Canceled",
    discarded: "Discarded",
    ineligible: "Ineligible",
    not_interested: "Not Interested",
    not_returned: "Not Returned",
    prepare: "Prepare",
    rejected: "Rejected",
    expired: "Expired",
    exhausted: "Exhausted",
    denied: "Denied",
    clear_all: "Clear All",
    clear: "Clear",
    manage_patient_details: "Manage Patient Details",
    dob: "DOB",
    phone_number: "Phone Number",
    clear_date: "Clear date",
    financial: "Financial",
    total_income_yearly: "Total Income Yearly",
    total_household_size: "Total Household Size",
    assignees: "Assignees",
    assignee: "Assignee",
    unassigned: "Unassigned",
    no_assignees: "No assignees",
    no_assignee: "No assignee",
    no_physician: "No physician",
    no_facility: "No facility",
    clear_assignees: "Clear assignees",
    facility: "Facility",
    select_facility: "Select facility",
    select_date: "Select date",
    no_oop_limit: "No out-of-pocket limit",
    non_covered_events: "Non covered events",
    inactive_coverage: "Inactive coverage",
    in_network: "In network",
    oop_limit: "Out-of-pocket limit",
    other: "Other",
    deceased: "Deceased",
    select: "Select",
    invalid_fields_should_be_corrected: "Invalid fields should be corrected",
    edit_patient_details: "Edit patient details",
    view_conflicts: "View Conflicts",
    input_required: "This is required.",
    no_patients_found: "No Patients Found!",
    no_enrollments_found: "No Enrollments Found!",
    ee_empty_state_title: "You've helped everyone today.",
    ee_empty_state_subtitle:
      "There are no new patients ready for express enrollment. Come back tomorrow to see who needs support next.",
    no_relevant_patients_found:
      "No patients match your current filters.\nTry adjusting the Status filter to see eligible patients.",
    no_saved_lists_found: "No lists found",
    no_saved_lists_to_show: "No Saved Lists to Show",
    no_favorite_to_show: "No Favorite lists found.",
    no_shared_lists_to_show: "No Shared Lists Found",
    no_shared_lists_to_show_description:
      "You haven't created or been added to any shared lists yet.\nCreate a list and choose who to share it with.",
    no_saved_lists_to_show_description:
      "There are no saved lists in your account yet.\nSelect any patient list to create a new one.",
    no_favorite_description: "You don't have any favorite lists yet.\nClick the star icon of any list to see it here.",
    submission_processing_title: "Submission is Processing...",
    submission_processing_description: "Please wait while we send the application to the manufacturer",
    invalid_date: "Invalid date",
    add_another: "Add Another {{label}}",
    remove: "Remove",
    sidebar_menu: {
      home: "Home",
      alerts: "Alerts",
      tasks: "Tasks",
      notifications: "Notifications",
      saved_lists: "Saved Lists",
      patients: "Patients",
      all_patients: "All Patients",
      visit_schedule: "Visit Schedule",
      high_priority: "High Priority",
      enrollments: "Enrollments",
      all_enrollments: "All Enrollments",
      pending_renewals: "Pending Renewals",
      claims: "Claims",
      all_claims: "All Claims",
      settings: "Settings",
      help_center: "Help Center",
      contact_support: "Contact Support",
      ai_chat_bot: "TeamMate AI",
      patient_enroll_sent: "Patient Actions",
      extra_care: "Extra Care"
    },
    view_editor: "View Editor",
    enter_text: "Enter text",
    form_errors: {
      invalid_email: "Invalid Email"
    },
    saved_lists_columns: {
      list_name: "List Name",
      last_modified: "Last Modified"
    },
    saved_list_messages: {
      delete_success: "Saved list deleted successfully",
      delete_error: "Could not delete saved list",
      search_error: "Could not search saved list",
      filter_error: "Could not filter saved list"
    },
    current: "Current",
    imported: "Imported",
    conflicts: "Conflicts",
    coverage_conflicts: {
      title: "Coverages Conflict",
      sub_title:
        "You can choose the correct policy. After you finish and update the policies, you can always reorder them.",
      no_issues_to_resolve: "Seems there's no unsolved conflicts",
      required_message: "Please select all fields",
      no_conflicts_to_resolve: "No Conflicts to resolve"
    },
    under_construction: {
      system_under_construction: "System under construction",
      diagnosis_under_construction: `We're improving how you can manage your patients' details.\nTo add/edit diagnoses for a patient, go to Manage Patient Details > Medical`
    },
    irrelevant: "Irrelevant",
    relevant: "Relevant",
    yes_sure: "Yes, I’m Sure",
    yes_edit_enrollment: "Yes, Edit Enrollment",
    no_create_new: "No, Create New",
    yes_delete: "Yes, Delete",
    main_blocks: {
      saved_list: "Saved Lists",
      all_patients: "All Patients",
      high_priority: "High Priority",
      visit_schedule: "Visit Schedule",
      pending_renewal: "Pending Renewals",
      all_applications: "All Applications",
      all_claims: "All Claims"
    },
    physician_popover: {
      part_one: "The Physician filter is showing patients according to their",
      assigned: "assigned",
      part_two: "physician. When used in the",
      visit_schedule: "Visit Schedule",
      part_three: "list - it will also include all patients with a planned visit for the selected physician/s."
    },
    yes: "Yes",
    no: "No",
    unknown: "Unknown",
    patient: "Patient",
    saved_list_pagination: {
      saved_list_page_count: "Showing: {{range_start}}-{{range_end}} Of {{total}} Lists",
      next: "Next"
    },
    all_claims_pagination: {
      all_claims_page_count: "{{range_start}}-{{range_end}} of {{total}} {{title}}",
      showing_range: "Showing: {{range_start}}-{{range_end}} of {{total}}",
      next: "Next",
      title: "Claims"
    },
    patients_pagination: {
      patients_page_count: "Showing: {{range_start}}-{{range_end}} of {{total}} {{title}}",
      showing_range: "Showing: {{range_start}}-{{range_end}} of {{total}}",
      many_patients: "many (more than {{max_count_treshold}})"
    },
    tableFilters: {
      patient: "Patient",
      insurance: "Insurance",
      visit_schedule: "Visit Schedule",
      visit_type: "Visit Type",
      high_priority: "High Priority",
      drug: "Drug",
      diagnosis: "Diagnosis",
      potential_savings: "Potential Savings",
      applications: "Applications",
      enrollments: "Enrollments",
      application_drug_name: "Drug Name",
      claim_drug_name: "Claim Drug Name",
      claim_location: "Claim Facility",
      maximum_available_funds: "Maximum Available Funds",
      application_valid_through_date: "Application Valid Through",
      age: "Age",
      status: "Status",
      import_status: "Import Status",
      patient_assignee: "Patient Assignee",
      enrollment_assignee: "Enrollment Assignee",
      claim_assignee: "Claim Assignee",
      patientFacility: "Patient Facility",
      visitFacility: "Visit Facility",
      physician: "Physician",
      visit_date: "Visit Date",
      follow_up_date: "Follow-up Date",
      min_patient_balance: "Min. Patient Balance",
      type: "Type",
      plan_market: "Plan Market",
      payer_name: "Payer Name",
      created_date: "Created Date",
      enrollment_creation_date: "Enrollment Creation Date",
      started_date: "Started Date",
      valid_through_date: "Valid Through Date",
      signature_status: "Signature Status",
      approved_date: "Approved Date",
      applied_date: "Applied Date",
      max_available_funds: "Maximum Available Funds",
      created_by_patients: "Created By Patients",
      min_remaining_oop: "Min. Remaining OOP",
      dose_form_category: "Dose Form Category",
      changed_date: "Changed date",
      name: "Name",
      code: "Code",
      diagnosis_name: "Diagnosis Name",
      diagnosis_code: "Diagnosis Code",
      diagnosis_date: "Diagnosis Date",
      diagnosis_type: "Diagnosis Type",
      drug_type: "Drug Type",
      application_status: "Application Status",
      enrollment_status: "Enrollment Status",
      assistance_program_status: "Assistance Program Status",
      ap_sponsor: "Assistance Program Sponsor",
      associated_drugs: "Associated Drug",
      claims: "Claims",
      claim_status: "Claim Status",
      claim_date: "Claim Date",
      claim_follow_up_date: "Follow-up Date",
      claim_submitted_date: "Submitted Date",
      date_of_service: "Date of Service",
      claim_received_date: "Posted Date",
      claim_time_since_last_activity: "Time Since Last Activity",
      claim_last_saved_by: "Last Saved By",
      application_type: "Application Type",
      claim_exists: {
        text: "Claim Exists",
        pop_up_content:
          "Filter by application status: approved, expired, and/or exhausted and application type: copay assistance, when utilizing this filter."
      },
      exists: "Yes",
      doesnt_exists: "No",
      invitation: "Invitation",
      invite_sent_date: "Invite Sent Date",
      patient_viewed_date: "Patient Viewed Date",
      patient_never_viewed: "Patient Never Viewed"
    },
    add_new_diagnosis: {
      title: "Add New Diagnosis",
      icd_label: "Diagnosis Name",
      cancel: "Cancel",
      add_diagnosis: "Add Diagnosis",
      icd_required_message: "Please choose diagnosis",
      icd_already_exists_message: "This Patient already has the diagnosis.",
      no_results_found: "No Results Found",
      icd_placeholder: "Enter diagnosis name or ICD code",
      active_date_placeholder: "Active Date",
      diagnosis_status_placeholder: "Diagnosis Status",
      primary_diagnosis_text: "This is a primary diagnosis"
    },
    columns: {
      sortById: "Click to sort descending/ascending by ID",
      record_mrn: "MRN-{{mrnRecord}}",
      record_phone: "Phone: {{mrnRecord}}",
      click_to_sort_ascending: "Click to sort ascending",
      click_to_sort_descending: "Click to sort descending",
      click_to_cancel_sorting: "Click to cancel sorting"
    },
    form_popups: {
      confirmed_close_title: "Unsaved Form Details",
      confirmed_close_content:
        "You have unsaved details in your form. Leaving the form will discard any unsaved changes.",
      add: "Add"
    },
    new_list_form: {
      cancel: "Cancel",
      save: "Save",
      update: "Update",
      save_as_new_list: "Save As New List",
      edit_list_info: "Edit List Info",
      unsaved_details: "Unsaved Details",
      not_saved_yet: "You haven’t saved yet. Leaving the form will discard any unsaved changes.",
      list_name: {
        placeholder: "Choose a name to identify this list",
        title: "List Name"
      },
      description: {
        placeholder: "Enter a description...",
        title: "Description (Optional)"
      },
      list_type: {
        placeholder: "Enter a description...",
        title: "List Type",
        private: {
          title: "Private",
          description: "Only you can view and edit this list."
        },
        public: {
          title: "Public",
          description: "This list will be viewable by all users. Only you can edit."
        }
      }
    },

    placeholders: {
      personal: {
        enter_alternate_contact_full_name: "Enter Alternate Contact Full Name",
        enter_first_name: "Enter First Name",
        enter_last_name: "Enter Last Name",
        enter_middle_name: "Enter Middle Name",
        enter_preferred_name: "Enter Preferred Name",
        enter_street_address: "Enter Street Address",
        enter_city: "Enter City",
        zip: "000000",
        relation_to_patient: "Enter Relation to Patient"
      }
    },

    assistance_program_form: {
      menu_title: "Add Assistance Program",
      title: "Add Patient Assistance Program",
      select_program: "Select Program",
      program_type: "Program Type",
      drug_name: "Drug Name",
      select_drug: "Select Drug",
      drug_name_placeholder: "Drug name",
      insurance_type: "Insurance Type",
      diagnosis_name: "Diagnosis Name",
      diagnosis_code: "Diagnosis ICD Code",
      filters: {
        copay_foundation: "Copay Foundation",
        copay_card: "Copay-Card",
        free_drug: "Free/Replacement Drug Program",
        government_plan: "Government Plans",
        living_expenses: "Living Expenses",
        commercial: "Commercial",
        federal: "Federal",
        medicaid: "Medicaid",
        medicare: "Medicare",
        uninsured: "Uninsured"
      },
      add_drug_form: {
        coverage_info: {
          info: "COVERAGE INFO",
          covered_by_payer: "Drug not covered by payer"
        },
        drug_name: {
          placeholder: "Drug Name",
          required_message: "Drug name is required",
          search: "Type to search"
        },
        dosage: {
          label: "Dosage",
          placeholder: "Drug dosage",
          required_message: "Dosage is required",
          tooltip_text:
            "Dosage field accepts numbers, decimal point and dashes. For drugs which have more than one active ingredient, please enter each ingredient's dose separated by a dash. For example, 24-26 or 1.5-2.5",
          error_validation: "Must be a valid number. May contain a '-' separator"
        },
        dosage_unit: {
          label: "Unit",
          placeholder: "Dosage unit",
          required_message: "Dosage unit is required"
        },
        units_per_day: {
          placeholder: "Units per day"
        },
        number_of_refills: {
          placeholder: "Number of Refills"
        },
        refill_frequency: {
          placeholder: "Refill Frequency (in days)"
        },
        date_picker: {
          placeholder: "Start date",
          required_message: "Start date is required"
        },
        administration_site: {
          placeholder: "Administration site",
          required_message: "Administration site is required"
        }
      },
      drug_not_associated:
        "The selected drug isn't on the patient's profile. To continue, click 'Add' below to create the program and medication automatically, or provide optional medication details below before adding.",
      drug_not_covered: "According to our records, this drug may not be covered by this program.",
      drug_not_associated_description: "Add missing patient drugs:",
      drug_administration_method: "Drug administration method:",
      fields_error: "Please complete all fields.",
      select_drug_error: "Please select drug.",
      failed_add_drug: "Failed to add drug",
      failed_add_assistance_program: "Failed to add assistance program"
    },
    //[DRUGS-TODO-AMIT] remove duplicated translate
    drugs: {
      menu_title: "Add Drug",
      title: "Add a new patient drug",
      add_drug_form: {
        form: {
          coverage_info: {
            info: "COVERAGE INFO",
            covered_by_payer: "Drug not covered by payer"
          },
          drug_name: {
            label: "Drug Name *",
            placeholder: "Drug Name",
            required_message: "Drug name is required",
            search: "Type to search"
          },
          dosage: {
            label: "Dosage",
            placeholder: "Drug dosage",
            required_message: "Dosage is required",
            tooltip_text:
              "Dosage field accepts numbers, decimal point and dashes. For drugs which have more than one active ingredient, please enter each ingredient's dose separated by a dash. For example, 24-26 or 1.5-2.5",
            error_validation: "Must be a valid number. May contain a '-' separator"
          },
          dosage_unit: {
            label: "Unit",
            placeholder: "Dosage unit",
            required_message: "Dosage unit is required"
          },
          doses_per_day: {
            placeholder: "Doses per Day",
            required_message: "Number of doses per day is required"
          },
          units_per_day: {
            placeholder: "Units per day"
          },
          number_of_refills: {
            placeholder: "Number of Refills",
            required_message: "Please enter refill amount"
          },
          refill_frequency: {
            placeholder: "Refill Frequency (in days)"
          },
          date_picker: {
            placeholder: "Start date",
            required_message: "Start date is required"
          },
          administration_site: {
            placeholder: "Administration site",
            required_message: "Administration site is required"
          },
          num_of_cycles: {
            placeholder: "Number of Cycles",
            required_message: "Please enter the number of cycles"
          },
          physician: {
            label: "Physician",
            choose_physician: "Choose Physician"
          }
        }
      },
      edit_drug_form: {
        form: {
          edit_physician: "The choice of physician will impact all instances of the same drug."
        }
      }
    },
    form: {
      physician: {
        label: "Physician",
        placeholder: "-",
        error_required: "Please input physician",
        popover: {
          npi: "NPI",
          dea: "DEA",
          stateLicense: "State License",
          phone: "Phone",
          fax: "Fax",
          address: "Address",
          email: "Email"
        }
      },
      refills: {
        label: "Refills",
        placeholder: "Refills",
        error_required: "Please input Refills",
        zero_refills: "No refills"
      },
      order_type: {
        label: "Order Type",
        placeholder: "Order Type",
        free_text: "Free",
        replecement_text: "Replacement"
      },
      order_date: {
        label: "Order Date",
        placeholder: "Order Date",
        error_required: "Please input the order date"
      },
      admin_date: {
        label: "Admin Date",
        placeholder: "Admin Date",
        error_required: "Please input the admin date"
      },
      bill_voided: {
        label: "Bill Voided",
        placeholder: "Bill Voided",
        no_text: "No",
        yes_text: "Yes"
      },
      status: {
        label: "Status",
        placeholder: "Status"
      },
      quantity: {
        label: "Quantity",
        placeholder: "Quantity",
        error_required: "Please input the quantity"
      },
      dosage: {
        label: "Dosage",
        placeholder: "Dosage",
        error_required: "Please input the drug dosage",
        error_validation: "Must be a valid number. May contain a '-' separator",
        popover:
          "Dosage field accepts numbers, decimal point and dashes. For drugs with more than one active ingredient, enter each ingredient’s dose separated by a dash. For example, 24-26 or 1.5-2.5"
      },
      unit: {
        label: "Unit",
        placeholder: "Unit",
        error_required: "Please input the drug unit"
      },
      dosage_unit: {
        placeholder: "Dosage Unit"
      },
      cycle: {
        label: "Cycle",
        placeholder: "Cycle",
        error_required: "Please input cycle",
        per_patient: "Per Patient",
        per_cycle: "Per Cycle"
      },
      from_cycle: {
        label: "Apply from cycle",
        error_required: "Please input apply from cycle"
      },
      days_before: {
        label: "Days before/after admin",
        before: "Before",
        after: "After",
        error_required: "Please input days before/after administration"
      },
      days_between: {
        label: "Days between cycles",
        error_required: "Please input order frequency"
      },
      estimated_date: {
        label: "Estimated Delivery",
        placeholder: "Estimated Delivery Date",
        error_required: "Please input the estimated delivery date"
      },
      note: {
        label: "Note",
        placeholder: "Notes",
        error_required: "Please enter note",
        popover: "Enter note"
      },
      task: {
        label: "Task",
        placeholder: "Task text",
        error_required: "Please enter task",
        popover: "Enter task"
      },
      due_date: {
        label: "Due Date",
        placeholder: "Due Date",
        error_required: "Please input the task's due date"
      },
      assignee: {
        label: "Assignee",
        placeholder: "Assignee",
        error_required: "Please choose assignee",
        clear_assignee: "No assignee"
      },
      carrier: {
        label: "Carrier",
        placeholder: "Carrier",
        error_required: "Choose a carrier",
        fedex: "FedEx",
        ups: "UPS",
        usps: "USPS",
        dhl: "DHL",
        amazon: "Amazon"
      },
      rx_instructions: {
        label: "Rx instructions",
        empty_placeholder: "-",
        placeholder: "Enter instructions",
        error_required: "Rx instructions required"
      },
      rx_number: {
        label: "Rx number",
        empty_placeholder: "-",
        placeholder: "Enter number",
        error_required: "Rx number required"
      },
      tracking_number: {
        label: "Tracking No.",
        placeholder: "Tracking Number",
        error_required: "Please input one tracking number",
        error_pattern: "Tracking Number must contain only numbers and letters"
      }
    },
    support: {
      please_provide_relevant_details_below: "Please provide the relevant details below",
      title: "Contact Support: {{ name }}",
      disclaimer: "Please do not input protected health information (ePHI) in the subject",
      description: "Description *",
      subject: "Subject *",
      description_required: "Description is required",
      subject_required: "Subject is required"
    },
    header_searchbar: {
      searched_patients: "Patient",
      show_all_results: "Show {{totalPatients}} results",
      show_more: "Show More",
      searched_patients_assignees: "Assignee",
      autocomplete_search_results_list: {
        name_id: "No patients found",
        dob: "For results, enter the patient’s full DOB.",
        phone_number: "For results, enter the patient’s full phone number.",
        social_security_number: "For results, enter the patient’s full SSN.",
        no_results: "No Results Found"
      },
      option_type_list: {
        name_id: "Name / ID",
        dob: "Date of Birth",
        phone: "Phone",
        ssn: "SSN"
      },
      placeholder: {
        name_id: "Search patients by Name, ID or MRN",
        dob: "MM/DD/YYYY",
        phone_number: "(000) 000-0000",
        social_security_number: "123-12-1234"
      },
      results_title: {
        dob: "DOB",
        phone_number: "Phone",
        social_security_number: "SSN",
        name_id: "Name, ID",
        recently_viewed: "Recently Viewed",
        assignee: "Assignee"
      }
    },
    assistance_programs: {
      search_placeholder: "Search by Program Name",
      table: {
        name: "Name",
        provided_by: "Provided By",
        type: "Type",
        Insurance: "Insurance",
        diagnosis: "Diagnosis",
        grant_amount: "Grant Amount",
        status: "Status"
      },
      filters: {
        title: "FILTERS",
        fund_type: "Fund Type",
        diagnosis_name: "Diagnosis Name",
        diagnosis_code: "Diagnosis ICD Code",
        insurance_type: "Insurance Type",
        drug_name: "Drug Name",
        allowed_states: "Allowed States",
        show_only: "Show only open funds"
      },
      modal: {
        benefits: "Benefits",
        eligibility: "Eligibility",
        clinical_information: "Clinical Information",
        application_renewal_time_type: {
          automatically_renews:
            "Patients will be evaluated for ongoing eligibility to continue enrollment in the program. In the event patients experience a change in insurance coverage or BMS makes changes to the copay assistance program, patients may be required to re-enroll into the program and provide updated insurance information to determine eligibility.",
          regeneron_renewal_time_type:
            "Eligible Medicare patients: end of the year. All other eligible patients: 12 months from enrollment.",
          never_expires: "Never expires",
          time_to_renewal: "Expires {{applicationRenewalTimeInMonths}} months from first use or activation",
          expired_end_of_the_year: "Expires at the end of the calendar year",
          patient_dependent: "Patient Dependent"
        }
      }
    },
    patient_header: {
      more_info: {
        preferred_name: "Preferred Name",
        ssn: "SSN",
        email: "Email",
        address: "Address"
      }
    },
    new_patient: {
      form_fields: {
        first_name: "First Name *",
        last_name: "Last Name *",
        mrn: "MRN *",
        phone_number: "Phone Number *",
        dob: "Date of Birth *",
        middle_name: "Middle Name (Optional)",
        plan_markets: "Plan Market(s) *",
        drugs: "Drug(s) *",
        diagnoses: "Diagnoses *"
      },
      place_holders: {
        first_name: "Enter First Name",
        last_name: "Enter Last Name",
        mrn: "Enter MRN",
        middle_name: "Enter Middle Name",
        plan_markets: "Choose up to 3 coverage plan market(s)",
        drugs: "Enter drug name",
        diagnoses: "Enter diagnosis name or code"
      },
      minimize: "Minimize",
      find_ap_button: "Find Assistance Programs",
      find_ap_title: "Find Assistance Programs",
      find_ap_sub_title: "Please fill the information below to quickly find assistance programs for your patient.",
      what_next: "What would you like to do next?",
      patient_successfully_created: "Patient was successfully created!",
      save_and_find_ap: "Save Details and Find Programs",
      popover_subtitle:
        "Input the mandatory fields below. You always can add additional information as needed from the patient screen.",
      create_patient_button: "Create Patient",
      create_patient_tooltip: "Create a New Patient",
      editing_patient: "Editing Patient",
      adding_patient: "Adding Patient",
      failed_to_create_new_patient: "Failed to create a new patient",
      title: "Create a New Patient",
      adding_patient_message: "Please wait while we analyze the patient information...",
      title_editing: "Edit Patient",
      demographics: "Demographics",
      patient_label: "PATIENT NAME",
      email: "EMAIL",
      marital_status: "MARITAL STATUS",
      phone_number: "PHONE NUMBER",
      diagnosis: "Diagnosis",
      input_required: "This is required.",
      add_diagnosis: "Add Diagnosis",
      primary_diagnosis: "PRIMARY DIAGNOSIS",
      primary_diagnosis_camelCase: "Primary Diagnosis",
      diagnosis_uppercase: "DIAGNOSIS",
      date_of_birth_label: "DATE OF BIRTH",
      gender_label: "GENDER",
      gender_male: "Male",
      gender_female: "Female",
      address_label: "ADDRESS",
      household_size: "HOUSEHOLD SIZE",
      mrn_label: "MRN",
      physician_label: "PHYSICIAN",
      program_label: "PROGRAM",
      treatment_plan: "Treatment Plan",
      only_digits_rule: "Only digits are allowed",
      ssn_rule: "Please enter 9 digits",
      program_selection: "Program Selection",
      financial_and_insurance: "Financial and Insurance",
      financial: "Financial",
      primary_insurance: "PRIMARY INSURANCE",
      secondary_insurance: "SECONDARY INSURANCE",
      tertiary_insurance: "TERTIARY INSURANCE",
      financial_information: "FINANCIAL INFORMATION",
      effective_date: "Effective Date",
      patient_uninsured: "Patient is uninsured",
      add_policy: "Add Policy",
      other: "Other",
      other_uppercase: "OTHER",
      drug_event_uppercase: "DRUG EVENT",
      us_citizen: "US CITIZEN",
      drug_regimen_uppercase: "DRUG REGIMEN",
      radiotherapy_uppercase: "RADIOTHERAPY",
      imaging_uppercase: "IMAGING",
      visit_uppercase: "VISIT",
      other_payer_selected_message: "Payers added manually may not be supported for automatic benefit investigation.",
      no_automatic_investigation_message:
        "Payer is not currently supported for automatic benefit investigation and will require a manual benefit investigation by TailorMed’s Support team.",
      unknown_coverage_message:
        "Unknown coverage - The provided coverage information was not recognized by the system. Automatic benefits investigation may be affected.",
      drug_event: "DRUG EVENT",
      drug_regimen: "DRUG REGIMEN",
      radiotherapy: "RADIOTHERAPY EVENT",
      imaging: "IMAGING",
      visit: "VISIT",
      administration_site: {
        placeholder: "Administration Site",
        required: "Administration site is required"
      },
      next: "Next",
      submit: "Submit",
      update: "Update",
      add_treatment: "Add Treatment",
      add_event: "Add Event",
      cancel_modal_message:
        "You have unsaved patient details in your form. Leaving the form will discard any unsaved changes. What would you like to do?",
      stay_in_form: "Stay in Form",
      leave_anyway: "Leave anyway",
      cancel_modal_title: "Unsaved Patient Details",
      diagnosis_placeholder: "Select diagnosis or ICD code *",
      diagnosis_date_placeholder: "Diagnosis Date *",
      first_name_placeholder: "First Name",
      middle_name_placeholder: "Middle Name",
      last_name_placeholder: "Last Name",
      date_of_birth_placeholder: "Date of Birth",
      zip_code_placeholder: "ZIP Code",
      state_placeholder: "State",
      mrn_placeholder: "MRN",
      assistance_program_placeholder: "Assistance program",
      drug_name_placeholder: "Drug ame",
      unit_placeholder: "Select unit *",
      drug_dosage_placeholder: "Dosage",
      drug_unit_placeholder: "Dosage unit",
      cycles_placeholder: "Number of Cycles",
      order_frequency_placeholder: "Order Frequency *",
      cycles_frequency_placeholder: "Cycles Frequency (In Days)",
      current_cycle_placeholder: "Current cycle *",
      next_admin_date_placeholder: "Next admin date *",
      annual_income_placeholder: "Annual Income",
      household_size_placeholder: "Household Size",
      member_id_placeholder: "Member ID *",
      payer_name_placeholder: "Payer Name *",
      plan_market_placeholder: "Plan Market *",
      date_placeholder: "Date",
      treatment_placeholder: "Treatment",
      provider_placeholder: "Provider",
      number_of_fractions_placeholder: "Number of Fractions",
      imaging_area_placeholder: "Imaging Area",
      type_placeholder: "Type",
      drug_placeholder: "Drug Name",
      regimen_placeholder: "Regimen Name",
      treatment_id_placeholder: "Treatment ID",
      administration_type_placeholder: "Administration Type",
      doses_per_day_placeholder: "Doses Per Day",
      start_date_placeholder: "Start Date",
      diagnosis_tooltip: "Select diagnosis or ICD code",
      diagnosis_date_tooltip: "Diagnosis Date",
      assistance_program_tooltip: "Assistance program",
      drug_name_tooltip: "Drug name",
      drug_name_popover: "You may search for a drug by its generic or listed brand name, HCPC or NDC.",
      drug_brand_name_tooltip: "Drug brand name",
      unit_tooltip: "Select unit",
      cycles_tooltip: "Number of Cycles",
      order_frequency_tooltip: "Order Frequency",
      cycles_frequency_tooltip: "Cycles Frequency (In Days)",
      current_cycle_tooltip: "Current Cycle",
      next_admin_date_tooltip: "Next Admin Date",
      annual_income_tooltip: "Annual Income",
      household_size_tooltip: "Household Size",
      member_id_tooltip: "Member ID",
      payer_name_tooltip: "Payer Name",
      plan_market_tooltip: "Plan Market",
      date_tooltip: "Date",
      treatment_tooltip: "Treatment",
      provider_tooltip: "Provider",
      number_of_fractions_tooltip: "Number of Fractions",
      imaging_area_tooltip: "Imaging Area",
      type_tooltip: "Type",
      drug_tooltip: "Drug Name",
      regimen_tooltip: "Regimen Name",
      treatment_id_tooltip: "Treatment ID",
      administration_type_tooltip: "Administration Type",
      administration_site_tooltip: "Administration Site",
      doses_per_day_tooltip: "Doses Per Day",
      start_date_tooltip: "Start Date",
      effective_date_tooltip: "Effective Date",
      other_payer_exists: '"Other" payer already exists',
      other_payer_exists_content: `
      We have identified that the payers you manually added {{payerNames}}
      are already supported by the system. Below are the optional
      payer names that matches. Please choose the matching payer
      from the list:
      `,
      required_fields_error: "Please complete all required fields.",
      mrn_only_english: "MRN should include only numeric string or English letters.",
      mrn_must_contain_numbers: "MRN should contain both numbers and letters, or only numbers.",
      patient_already_exist_error: "The patient already exists. ",
      view_existing_patient_link: "View Patient"
    },
    date_range_filter: {
      date_range: "Date Range"
    },
    column_selector: "Column Selector",
    patientsTasks: {
      mrn: ", MRN: {{mrn}}",
      title: "Tasks for All Patients",
      tasks_for: "Tasks for",
      add_task: "Add Tasks",
      all_assignees: "All assignees",
      unassigned: "Unassigned",
      show_all: "Show all",
      not_done: "Not done",
      done: "Done",
      all_times: "All times",
      within_a_week: "Within a week",
      within_a_month: "Within a month",
      date_range: "Date range",
      back_to_tasks: "Back to tasks",
      task: "Task *",
      tasks: "Tasks",
      this_is_required: "This is required",
      due_date: "Due date",
      assignee: "Assignee",
      clear_assignee: "Clear assignee",
      add: "Add",
      update: "Update",
      load_more: "Load more",
      view_program: "View Program",
      export: {
        title: "Export",
        download_tasks: "Download displayed tasks",
        export_successful: "Export Successful.",
        export_failed: "Export Failed.",
        fileNamePrefix: "TM_FN_TaskList",
        sheetName: "Tasks",
        patient_id: "Patient ID",
        patient_mrn: "Patient MRN",
        patient_name: "Patient Name",
        assignee: "Assignee",
        task: "Task",
        due_date: "Due Date",
        status: "Status",
        assistance_program: "Assistance Program",
        created_at: "Created At",
        updated_at: "Updated At",
        created_by: "Created By",
        updated_by: "Updated By",
        done: "Done",
        not_done: "Not Done",
        completed_at: "Completed At",
        completed_by: "Completed By"
      }
    },
    patientTopSection: {
      mrn: "MRN",
      diagnoses: "Diagnoses",
      x_more_diagnoses: "+{{count}} more diagnoses",
      dob: "DOB",
      age: "Age",
      phone_number: "Phone",
      employer: "Employer",
      status: "Status",
      import_status: "Import Status",
      assignees: "Assignees",
      facility: "Facility",
      physician: "Physician",
      follow_up_date: "Follow-up date",
      financial: "Financial",
      fpl: "FPL",
      add_fpl: "Add FPL",
      add_fpl_tooltip: "Add FPL details to refine potential savings recommendations.",
      insurance: "Insurance",
      show_more: "Show More",
      show_less: "Show Less",
      high_priority: "High Priority",
      exclude_high_priority: "Exclude program from High Priority",
      exclude_patient_from_high_priority: "Exclude patient from High Priority list (from all programs)",
      deceased: "Deceased",
      data_conflicts: "IMPORTED DATA CONFLICTS",
      preferred_language: "Preferred Language",
      caregiver: "Caregiver",
      relation_to_patient: "Relation to Patient",
      success_message_update_preferred_language: "Updated patient preferred language successfully",
      failed_message_update_preferred_language: "Failed to update patient preferred language",
      contact_details: "Contact Details",
      alternate_contact_details: "Alternate Contact Details",
      name: "Name",
      email: "Email",
      contact_instead_of_patient: "Contact Instead of Patient",
      ok_to_speak_to: "Ok to Speak to",
      more_insurance: "more insurance"
    },
    totalUniqueDrugs: {
      tooltip: "Active medications have a medication event in the last 6 months",
      title: "Active Medications",
      show_drugs_button: "Show Drugs",
      non_iv_drugs: "Non-IV Drugs",
      iv_drugs: "IV Drugs",
      infusion_drugs: "Infusion",
      subcutaneous_drugs: "Subcutaneous",
      oral_and_others: "Oral/Others",
      unspecified: "Unspecified",
      no_medications_found: "No active medications found",
      add_medication: "Add Medication"
    },
    patientCoverageSummary: {
      number_of_coverages: "{{number}} Coverage",
      coverage_summary: "Coverage Summary {{amount}}",
      no_coverages_found: "No coverages found",
      add_coverage: "Add Coverage",
      view_all: "View All",
      no_oop_limit: "No OOP Limit",
      remaining_oop: "Remaining OOP: ${{remainingOOP}}"
    },
    patientRSActions: {
      attachments: "Attachments",
      tasks: "Tasks",
      attachments_for: "Attachments for",
      by_date_of: "By date (Oldest first)",
      by_date_nf: "By date (Newest first)",
      by_name_az: "By name (A -> Z)",
      by_name_za: "By name (Z -> A)",
      all: "All",
      FN_attach: "FN attach, only",
      Pharmacy_attach: "Pharmacy attach, only",
      uploaded_at: "Uploaded at",
      attachments_disabled: "You  don’t have permissions to download this file",
      message_confirm: "Are you sure you want to delete this file?",
      view_only: "VIEW ONLY",
      e_consent: "eConsent",
      via: "via",
      notes: {
        notes: "Notes",
        notes_for: "Notes for {{name}}",
        add_note: "Add note",
        delete_note_popup_title: "Confirm Delete",
        delete_note_popup_content: "Are you sure that you want to delete this note?",
        keep_note: "Keep note",
        delete_note: "Delete note"
      }
    },
    patientOverview: {
      overview: "Overview",
      disable_patient_report: "Coming Soon - New and Improved Patient Report",
      patient_journey: "Patient Journey",
      coverage_details: "Coverage Details",
      potential_savings: "Potential Savings",
      applications: "Applications",
      enrollments: "Enrollments",
      communication: "Communication",
      treatment: "All Medications",
      showing_events: "Showing events {{startingNumber}} - {{endingNumber}} out of {{endingNumber}} events",
      journey_impact: "Journey Impact",
      coverage_summary: "Coverage Summary",
      estimated_oop: "Estimated OOP",
      oop_estimatation: "OOP Estimation",
      oop_year: "Year",
      oop_source: "Source",
      edit_oop: "Edit OOP",
      total: "Total ({{year}})",
      remaining: "Remaining ({{year}})",
      please_check_in_again: "Please check it again in a while.",
      automatic_benefit_investigation_not_supported_will_update:
        "Automatic benefit investigation is not supported for this patient due to lack of coverage data. The system will update once coverage data is received.",
      automatic_benefit_investigation_not_supported:
        "Automatic benefit investigation is not supported for this patient.",
      no_support_for_automatic_benefit_investigation_lack_coverage_data:
        "No support for automatic benefit investigation due to lack of coverage data.",
      no_support_for_automatic_benefit_investigation: "No support for automatic benefit investigation.",
      no_potential_savings_found: "No programs to show - yet!",
      add_more_data:
        "To match you with assistance programs, we'll need more patient information. Add the missing pieces and we'll try again.",
      add_patient_details: "Add Patient Details",
      request_manual_analysis: "Request Manual Analysis",
      manual_analysis_requested: "Manual Analysis Requested",
      automatic_oop_estimation_not_supported: "Automatic Out-of-pocket estimation is not supported for this patient.",
      oop_estimation_not_performed: "OOP Estimation not performed.",
      in_analysis: "In Analysis",
      sick_days: "Sick Days",
      caregiver_days: "Caregiver Days",
      approved: "Approved",
      applicable: "Applicable",
      assistance_programs: "{{number}} Assistance Programs:",
      government_plans: "Government Plan",
      deductible: "Deductible",
      copay_assistance: "Copay Assistance",
      free_drugs: "Free drugs",
      other: "Other",
      living_expenses: "Living expenses",
      assuming_continued_coverage: "Assuming continued coverage",
      oop_next_six_months: "OOP (next 6 months)",
      oop_unitl: "OOP (until",
      oop_total_journey: "OOP (total journey)",
      oop_estimatation_error: "Please input OOP Estimation!",
      year_error: "Please input OOP Year!",
      done: "Done",
      cancel: "Cancel",
      oop_table_oop_title: "OOP",
      oop_table_year_title: "For Year",
      oop_table_source_title: "Source",
      oop_table_user_title: "Name",
      oop_table_date_title: "Date",
      overview_totals_may_differ:
        "Overview totals may differ from potential savings because some programs fall under multiple categories (e.g., a foundation program may cover both copay and premium assistance).",
      manufacturer_pap: "Manufacturer PAP and Replacement",
      manufacturer_other: "Manufacturer Other",
      ancillary_living_expenses: "Ancillary/Living Expenses",
      premium_assistance: "Premium Assistance",
      manufacturer_other_tooltip: "Includes Quickstart, Trial, Bridge, Voucher, and Coupon/Rebate programs."
    },
    patientJourney: {
      event_description: "Event description",
      estimated_oop_cost: "Estimated out-of-pocket cost",
      drug: "Drug",
      cycles: "Cycles",
      cycle: "Cycle",
      dosage: "Dosage",
      generic_name: "Generic Name",
      brand_name: "Brand Name",
      jcode: "Jcode/HCPC",
      summary: "Summary",
      name: "Name",
      admin_type: "Admin Type",
      code: "Code",
      price: "Price",
      oop: "OOP",
      detailed: "Detailed",
      date: "Date",
      drug_name: "Drug Name",
      coverage_details: "Coverage Details",
      admin: "Admin",
      total_oop: "Total OOP",
      not_guaranteed_price_estimate:
        "This is not a guaranteed price estimate. Out of pocket estimates may change based of payers decisions, changes to care plans and internal hospital decisions.",
      applicable_potential_savings: "Applicable Potential Savings",
      matches_assistance_programs: "Matches of Assistance Programs",
      assistance_program: "Assistance Program",
      update: "Update",
      drug_coverage: "Drug Coverage",
      to_detect: "to detect additional assistance programs",
      show_info: "Show Info",
      patient_journey_details_unavailable: "Journey details are currently unavailable",
      no_treatment_information_for_this_patient:
        "It seems that there is no treatments information for this patient. The system will update this section as it will become available.",
      the_system_will_update:
        "The system will update this section as it will become available. Please check again in a while.",
      government_plan: "Government Plan",
      in_analysis: "In Analysis",
      copay_foundation: "Copay Foundation",
      free_drug: "Free Drug",
      living_and_transport_expenses: "Living and Transport Expenses",
      other: "Other",
      government_plans: "Government Plans",
      ordering_physicians: "Ordering Physician(s):",
      ordering_physicians_description: "The physician(s) who ordered the drugs specified in the journey event",
      drug_events: "Drug Events",
      more_details: "More Details",
      cost_estimation: "Cost Estimation"
    },
    patientClassicCoverageDetailsOverview: {
      payer_name: "Payer Name",
      expired: "EXPIRED",
      reactivate: "Reactivate",
      fill_required_fields: "Please fill the required fields",
      saving_changes: "Saving changes",
      edit: "Edit",
      payer: "Payer",
      delete: "Delete",
      switch_with: "Switch with",
      other: "Other",
      plan_started: "PLAN STARTED",
      plan_ends: "PLAN ENDS",
      group_id: "Group ID",
      member_id: "Member ID",
      plan_market: "Plan Market",
      search_by_payer: "Search by payer name",
      select_plan_market: "Select Plan Market",
      insert_member_id: "Please insert member ID",
      search_payer: "Search Payer",
      delete_confirmation: "Are you sure you wish to delete this coverage?",
      delete_with_type_confirmation:
        "Are you sure you want to delete the {{coverageType}} coverage ? This will change the order of the other coverages.",
      delete_coverage: "Delete Coverage",
      yes_delete: "Yes, Delete",
      add_new_coverage: "Add New Coverage",
      add_coverage: "Add Coverage",
      coverage_with_the_same_payer_name_and_member_ID:
        "A coverage with the same Payer name and Member ID already exists",
      prescription_benefit: "Prescription Benefit",
      rx_member_id: "Rx Member ID",
      rx_plan_name: "Rx Plan Name",
      rx_bin: "Rx BIN",
      rx_pcn: "Rx PCN",
      rx_group: "Rx GRP",
      benefit_type: "Coverage Type", // we use coverage type instead of benefit type since the user is adding a coverage , in our system coverage type is referred to primary, secondary, tertiary
      choose_benefit_type: "Choose Coverage Type",
      prescription_benefit_type: "Prescription",
      medical_benefit_type: "Medical",
      medical_and_prescription_benefit_type: "Medical + Prescription",
      lose_filled_data_title: "Coverage Type",
      lose_filled_data_content:
        "Changing coverage types will remove {{benefitType}} information. Would you like to continue?",
      lose_filled_data_confirmation: "Continue",
      lose_filled_data_cancel: "Cancel"
    },
    patientCoverageDetailsTabs: {
      delete_confirmation: "Are you sure you wish to delete these coverages?",
      primary_coverage: "Primary Coverage",
      secondary_coverage: "Secondary Coverage",
      tertiary_coverage: "Tertiary Coverage",
      unknown_coverages: "Unknown Coverages",
      unspecified_coverages: "Unspecified Coverages",
      overview: "Overview",
      drugs: "Drugs",
      benefits: "Benefits",
      documents: "Documents",
      payer_details: "Payer Details",
      coverages_can_always_be_added: "Coverages can always be added"
    },
    coverages: {
      save_changes: "OK, Save Changes",
      redirect_message: "We are redirecting you to a different page, any made changes will be saved.",
      changing_coverage_details_message:
        "Changing the coverage details may initiate a new benefit investigation process. Calculated insurance information may be affected."
    },
    patientCoverageDetails: {
      no_coverage_info: "No Coverage info set yet",
      no_coverage_yet: "No coverages yet",
      payer_name: "Payer Name",
      plan_market: "Plan Market",
      plan_name: "Plan Name",
      in_network: "In Network",
      out_network: "Out Network",
      out_of_network: "Out-of-Network",
      payer: "Payer",
      group_id: "Group ID",
      member_id: "Member ID",
      plan_restart: "Plan Restart",
      coverage: "Coverage",
      coinsurance: "Coinsurance",
      summary_of_benefits: "Summary of Benefits",
      evidence_of_coverage: "Evidence of Coverage",
      drug_formularies: "Drug Formularies",
      provider_directory: "Provider Directory",
      phone_number: "Phone Number",
      website: "Website",
      address: "Address",
      coverage_data_check_up: "Coverage data check up",
      click_get_coverage: "Click ‘Get coverage’ to obtain the patient’s coverage information",
      get_coverages: "Get coverages",
      initial: "Initial",
      latest: "latest",
      refresh: "Refresh",
      coverage_details_unavailable: "Coverage details are currently unavailable",
      the_system_will_update:
        "The system will update this section as it will become available. Please check again in a while.",
      deductible: "Deductible",
      oop_max: "OOP Max",
      coverage_data_refreshed_success: "Coverage data has been refreshed successfully.",
      coverage_data_refreshed_failure: "Coverage data has not been refreshed."
    },
    potentialSavingsModal: {
      benefits: "Benefits",
      eligibility_criteria: "Eligibility Criteria",
      potential_savings: "Potential Savings",
      application_link: "Application Link",
      program_website: "Program Website",
      current_status: "Current Status",
      used: "used",
      new_enrollment_header: "Enrollment Already Exists",
      new_enrollment_content: "An enrollment for this assistance program is already in progress.",
      would_you_like_to_edit_existing_enrollment: "Would you like to edit the existing enrollment?"
    },
    errorMessages: {
      update_patient_details_failed: "Failed to update patient details",
      failed_to_get_imported_statuses: "Failed to get imported Statuses",
      failed_to_update_assignees: "Failed to update assignees",
      failed_to_update_patient_status: "Failed to update patient status",
      error_while_downloading_form: "An error has occurred downloading the form",
      failed_to_add_drugs: "Failed to add drugs",
      failed_to_check_if_pdf_exists: "Failed to check if pdf exists",
      drug_calculation_failed: "Drug cost calculation failed",
      failed_to_update_drugs_calculations: "Failed to update drugs calculations",
      failed_to_get_drugs: "Failed to get drugs",
      failed_to_create_patient: "Failed to create patient",
      failed_to_edit_patient: "Failed to edit patient",
      failed_to_uninsure_patient: "Failed to delete patient insurances",
      failed_to_edit_coverage: "Failed to edit coverage",
      failed_to_create_coverage: "Failed to create coverage",
      failed_to_delete_coverage: "Failed to delete coverage",
      patient_creation_failure: "Patient Creation Failure",
      please_contact_support: "Please contact support.",
      diagnosis_names: "Failed to get diagnosis names.",
      diagnosis_icds: "Failed to get diagnosis ICDs.",
      diagnosis_search: "Failed to search diagnoses.",
      drugs_search: "Failed to search drugs.",
      regimens_search: "Failed to search regimens.",
      payers_search: "Failed to search payers.",
      patient_data: "Failed to get patient data.",
      patient_starred: "Failed to edit patient starred.",
      top_opportunity_patients: "Failed to get Top opportunity patients",
      failed_to_update_physician: "Failed to update physician",
      failed_to_update_facility: "Failed to update facility",
      filterlist_starred: "Failed to update starred status.",
      failed_conflict_resolution: "Conflict resolution could not be saved",
      failed_to_add_pap: "Assistance Program could not be added",
      failed_to_add_pap_drug: "Drug could not be added",
      failed_to_add_pap_duplicate: "Assistance Program already exists for patient",
      failed_to_update_pap_information: "Failed to update Potential Savings information",
      enrollment_form_failed_to_create: "Enrollment form failed to create.",
      failed_to_load_pdf_document: "Failed to preview the file.",
      reload: "Reload",
      signature_remove_fail: "signature requests failed to delete.",
      print_attachment_failed: "Print attachment failed",
      application_form_update_failed: "Something went wrong. Please refresh the page",
      should_be_less_than: "{{fieldName}} should be less than {{maxCharacter}} character"
    },
    successMessages: {
      updated_patient_details: "Patient details updated successfully",
      conflicts_solved_successfully: "Conflicts resolved successfully",
      patient_details_updated_successfully: "Patient details updated successfully",
      updated_assignees_successfully: "Updated assignees Successfully",
      updated_patient_status_successfully: "Updated patient status successfully",
      drug_added_successfully: "Drug was added successfully",
      deleted_patient_coverages_successfully: "Deleted patient coverages successfully",
      deleted_coverage_successfully: "Deleted coverage successfully",
      coverage_created_successfully: "Coverage created successfully",
      coverage_updated_successfully: "Coverage updated successfully",
      successfully_added: "Patient {{patientId}} created - analyzing data in progress",
      successfully_edited: "Patient {{patientId}} edited successfully",
      successfully_updated_physician: "Updated physician Successfully",
      successfully_updated_facility: "Updated facility Successfully",
      successfully_conflict_resolution: "Conflict resolution was saved successfully",
      apa_created_successfully: "New enrollment created successfully",
      enrollment_created_successfully: "New enrollment has been created",
      copy_to_clipboard_successfully: "The Information Was Successfully Copied To Clipboard.",
      enrollment_form_was_generated_successfully: "Enrollment form generated successfully",
      deleteSignature: "Request for signatures was deleted successfully."
    },
    managePatientDetails: {
      editInWorksheet: "Edit In worksheet",
      cancel_discard: "Back",
      date_of_birth: "Date of Birth",
      preferred_language: "Preferred Language",
      placeholder: { preferred_language: " Select Preferred Language" },
      phone: "Phone",
      phone_required: "Phone is required",
      alternate_contact_phone: "Alternate Contact Phone",
      full_name: "Full Name",
      alternate_contact_full_name: "Alternate Contact Full Name",
      alternate_contact_email: "Alternate Contact Email",
      contact_instead_of_patient: "Contact instead of patient",
      ok_to_speak_to: "Ok to speak to",
      full_name_required: "Name is required",
      relation_to_patient: "Relation to Patient",
      manage_patient_details: "Manage Patient Details",
      personal: "Personal",
      financial: "Financial",
      medical: "Medical",
      medications: "Medications",
      patient_is_uninsured: "This patient is uninsured",
      email: "Email",
      phone_number: "Phone Number",
      address: "Address",
      city: "City",
      state: "State",
      zip: "ZIP",
      marital_status: "Marital Status",
      marital_status_placeholder: "Choose one",
      undefined: "Undefined",
      single: "Single",
      married: "Married",
      separated: "Separated",
      divorced: "Divorced",
      widowed: "Widowed",
      social_security_number: "Social Security Number",
      household_size: "Household Size",
      adults: "Adults",
      children: "Children",
      total: "Total",
      us_citizen: "US Citizen",
      legal_resident: "Legal Resident",
      veteran: "Veteran",
      disabled: "Disabled",
      patient_is_deceased: "This patient is deceased",
      reset_patient_data: "Reset patient data",
      done: "Done",
      patient_data_updated: "Patient data has been updated successfully",
      patient_personal_data_could_not_be_updated: "Patient personal data could not be updated",
      the_patient_data_has_been_unlocked: "The patient data has been unlocked successfully",
      all_manual_changes_will_be_reset:
        "All manual changes and additions will be reset, and the patient`s data will be set automatically according to the data arriving from the ERM. This action can`t be reverted",
      cancel: "Cancel",
      approve: "Approve",
      patient_weight_lbs: "Patient weight (lbs)",
      monthly_income: "Monthly Income",
      annual_income: "Annual Income",
      monthly_household_income: "Monthly Household Income",
      annual_household_income: "Annual Household Income",
      patient_allergies: "Allergies",
      patient_allergies_placeholder: "Enter patient's allergies",
      patient_weight: "Weight",
      patient_weight_placeholder: "Weight",
      patient_height: "Patient Height",
      patient_height_placeholder: "Height",
      monthly: "Monthly",
      yearly: "Yearly",
      salary: "Salary",
      social_security: "Social Security",
      disability: "Disability",
      unemployment: "Unemployment",
      pension: "Pension",
      stocks: "Stocks",
      dividends: "Dividends",
      child_support: "Child Support",
      food_stamps: "Food Stamps",
      other: "Other",
      fpl: "FPL",
      enter_amount: "Enter Amount",
      fpl_is_calculated: " is calculated based on household size and gross annual household income",
      income_verification_date: "Income Verification Date",
      files_taxes: "Files Taxes",
      household_Size: "Household Size",
      drugName: "Drug",
      proof_of_income_information: "Proof of Income Information",
      proof_of_income_information_placeholder: "Enter Details",
      name: "Name",
      cycles: "Cycles",
      admin_type: "Admin Type",
      start_date: "Start Date",
      end_date: "End Date",
      visibility: "Visibility",
      physician: "Physician",
      unhide: "Unhide",
      hide_drugs: "Hide drug from all screens, calculations and approved savings matching",
      please_wait_updating_relevant: "Please wait. Updating relevant assistance programs and OOP estimation",
      mark_drug_as: "Mark {{drugName}} as {{coveredOrUncovered}} by payer",
      covered: "covered",
      uncovered: "uncovered",
      confirm: "Confirm",
      confirm_drug_discontinued_date: "Confirm drug discontinued date",
      are_you_sure_discontinue_drug:
        "Are you sure you want to discontinue this drug? Once the drug is discontinued, you will not be able to undo this action.",
      please_wait_discontinued_date: "Please wait while discontinued date is updated...",
      please_wait_drug_visibility: "Please wait while drug visibility preference is being updated...",
      drug_visibility_updated: "Drug visibility preference updated successfully",
      assistance_programs_updated: "assistance programs updated: {{addedAmount}} added, {{removedAmount}} removed",
      youve_just_discontinued_drug:
        "You've just discontinued this drug. Note that if this drug arrives again in the data after TODAY, it will be created",
      no_treatment_data: "No treatment data specified for patient",
      cancel_modal_title: "Unsaved Changes",
      selecting_us_citizen: "Selecting 'US citizen' will automatically check 'Legal Resident' as well",
      usPhonePattern: "(000) 000-0000",
      please_enter_digits: "Please enter 10 digits.",
      coverage: "Coverage",
      select_date: "Select a date",
      conflicts_detected: "Conflicts Detected",
      email_placeholder: "name@mail.com",
      email_invalid: "Email isn't valid",
      email_required: "Email is required",
      social_security_number_placeholder: "123-12-1234",
      address_placeholder: "Olvera Street",
      state_placeholder: "Select State",
      city_placeholder: "Los Angeles",
      zip_placeholder: "Ex. 647483",
      add_diagnosis: "+ Add Diagnosis",
      diagnosis: "Diagnosis",
      last_insurance_reviewed_by: "Last Insurance Review by {{user}} on",
      mark_as_reviewed: "Mark as reviewed",
      insurances_not_yet_reviewed: "Last Insurance Review on",
      last_insurance_reviewed_info:
        "Manually update the date when the patient’s insurance was last reviewed. This date will not update automatically.",
      income_breakdown_modal_approve: "Ok",
      income_breakdown_modal_title: "Income Breakdown Edit",
      income_breakdown_modal_body: 'Switching to "Income Breakdown" will delete the current total amounts.',
      medications_section: {
        add_medication: "+ Add Medication",
        manually_added_medications: "Manually Added Medications",
        imported_medications: "Imported Medications",
        medication_modal: {
          cancel: "Cancel",
          update: "Update",
          add_medication: "Add Medication",
          edit_medication: "Edit Medication",
          add_new_medication: "Add New Medication",
          medication_form: {
            coverage_info: {
              info: "COVERAGE INFO",
              covered_by_payer: "Drug not covered by payer"
            },
            drug_name: {
              label: "Drug Name",
              placeholder: "Enter any drug",
              search_placeholder: "Search for any drug"
            },
            dose_form: {
              label: "Dose Form",
              placeholder: "Select Dose Form"
            },
            strength: {
              label: "Strength",
              placeholder: "Select Strength"
            },
            dosage: {
              label: "Dosage",
              placeholder: "Dosage Amount",
              validation_error: "Must be a valid number. May contain a '-' separator"
            },
            dosage_unit: {
              label: "Unit",
              placeholder: "Dosage unit",
              required_message: "Dosage unit is required"
            },
            doses_per_day: {
              placeholder: "Doses per Day",
              required_message: "Number of doses per day is required"
            },
            units_per_day: {
              label: "Units per day",
              placeholder: "0"
            },
            num_of_cycles: {
              label: "Number of Fills / Cycles",
              addon_before: "No.",
              placeholder: "0",
              required_message: "Please enter the number of cycles"
            },
            days_supply: {
              label: "Days Supply",
              placeholder: "0",
              required_message: "Days supply is required"
            },
            start_date: {
              label: "Start date",
              required_message: "Start date is required"
            },
            administration_site: {
              placeholder: "Administration site",
              required_message: "Administration site is required"
            },
            physician: {
              label: "Physician",
              choose_physician: "Choose Physician",
              edit_physician: "The choice of physician will impact all instances of the same drug."
            },
            pack: {
              label: "Pack",
              placeholder: "Select pack"
            }
          }
        }
      }
    },
    patientPrint: {
      financial_navigation_report: "Financial Navigation Report",
      patient_details: "Patient Details",
      treatment_plan: "Treatment Plan",
      recommended_rograms: "Recommended Programs",
      out_of_pocket_estimation: "Out Of Pocket Estimation",
      diagnosis: "Diagnosis",
      welcomeMessage: "Dear {{patientName}}, we gathered for you the following details",
      treatment: "Treatment",
      oop_estimation: "OOP Estimation",
      sick_days: "Sick Days",
      caregiver_days: "Caregiver Days"
    },
    patientPotentialSavings: {
      prepare_new_enrollment: "Prepare New Enrollment",
      prepare_new_enrollment_second_button: "Prepare New",
      send_to_patient: "Send Link to Patient",
      missing_patient_info: "Missing Patient Info",
      missing_patient_email: "Missing Patient Email",
      missing_patient_phone_number: "Missing Patient Phone Number",
      patient_opted_out: "The patient has chosen not to receive information about this program.",
      opt_out_check_failed: "Unable to verify opt-out status. Please try again later.",
      please_update_here: "Please update here",
      add_details: "Add Details",
      add: "Add",
      phone1: "Phone 1",
      phone2: "Phone 2",
      fax: "Fax",
      missing_FPL_details: "Missing <1>FPL</1> details",
      FPL_exceeds_max_FPL: "<1>FPL</1> exceeds program limit",
      FPL: "FPL",
      FPL_exceeds_max_FPL_long_message:
        "Patient's <1>FPL</1> exceeds program limit - please contact assistance program sponsor to confirm eligibility.",
      missing_FPL_details_long_message:
        "Patient’s <1>FPL</1> details are missing - the patient might not be eligible for this program",
      no_programs_to_show: "No programs to show - yet!",
      add_more_data_description:
        "To match you with assistance programs, we'll need more patient information. Add the missing pieces and we'll try again.",
      reject_reason_list: "Please select a reject reason from the list below:",
      add_more_data:
        "Patient's {{missingElements}} details are missing. Add details to refine potential savings recommendations",
      add_more_data_prefix: "Patient's ",
      add_more_data_suffix: " details are missing. Add details to refine potential savings recommendations",
      reject_reason: "Reject Reason",
      rejectReasonList: {
        patient_not_eligible: "The patient is not eligible",
        patient_not_receiving: "The patient is not receiving the relevant medication",
        patient_not_active_treatment: "The patient is not in active treatment",
        demographic_related: "Demographic related (FPL, Age or Location)",
        diagnosis_not_eligible: "Diagnosis not eligible",
        coverage_not_eligible: "Coverage not eligible",
        patient_sufficiently_covered: "The patient is sufficiently covered by their insurance",
        oop_limit_reached: "The OOP limit has been reached",
        patient_already_receiving_fn: "The patient is already receiving financial assistance",
        patient_rejected_assistance: "The patient rejected assistance",
        patient_receiving_assistance_different_facility: "The patient is receiving assistance in a different facility"
      },
      search: "Search",
      add_program: "Add Program",
      assistance_programs_matches: "Matches of Assistance Programs",
      program_type: "Program Type",
      copay_card: "Copay Card",
      copay: "Copay Foundation",
      free_drug: "Free/Replacement Drug Program",
      government_plan: "Government Plans",
      living_expenses: "Living Expenses",
      government_plans: "Government Plans",
      internal: "Internal",
      all_program_types: "All Program Types",
      program_types_placeholder: "Please Select Program Types",
      no_type_selected: "No Type Selected",
      please_select: "Please select",
      program_status: "Program Status",
      not_seeing_a_program: "Not seeing a program you expect to see here?",
      check: "Check",
      drugs_coverage: "Drugs Coverage",
      coverage_information_unavailable: "Coverage information is unavailable. Showing all relevant programs.",
      update_drug_coverage: "Update Drug Coverage to detect additional assistance programs.",
      update_coverage: "Update Coverage",
      drug_coverage_popup:
        "In case the patient has uncovered drugs it is necessary to update the system in order to receive the most relevant assistance programs.",
      high_priority: "High Priority",
      enrolled_by_tailorMed: "Enrolled by TailorMed",
      create_application: "Create Application",
      express_enroll: "Express Enroll",
      renew_application: "Renew",
      view_edit_application: "View / Edit",
      not_relevant: "Not Relevant",
      not_interested: "Not Interested",
      set_as: "Set as",
      ineligible: "Ineligible",
      enrollment_not_returned: "Not Returned",
      lookback_period: "Lookback Period",
      x_months_lookback: "{{count}} month lookback period",
      x_days_lookback: "{{count}} day lookback period",
      no_lookback_period: "No lookback period",
      application_status: "Application Status",
      enrollment_info: "Enrollment Information",
      who_can_enroll: "Who Can Enroll",
      patient_signature_required: "Patient Signature Required",
      patient_consent_required: "Required",
      patient_consent_not_required: "Not Required",
      benefits: "Benefits",
      eligibility: "Eligibility",
      clinical_information: "Clinical Information",
      contact_details: "Contact Details",
      enrollment_expiration_date: "Enrollment Expiration Date",
      offer_expiration_date: "Offer Expiration Date",
      maximum_number_of_uses: "Maximum Number of Uses",
      last_update: "Last Update",
      program_details: "Program Details",
      insurance_criterias: "Insurance Criteria",
      income_required: "Income Required (FPL)",
      program_eligibilitys: "Program Eligibility",
      drugs: "Drug",
      conditions: "Condition",
      application_link: "Application Link",
      program_website: "Program Website",
      pharmacy_website: "Pharmacy Website",
      bin: "BIN",
      pcn: "PCN",
      group_number: "Group Number",
      ap_last_updated: "AP Last Updated",
      all_programs_types: "All Programs Types",
      open: "Open",
      closed: "Closed",
      waitlist: "Accepting Waitlist",
      waitlist_tooltip: "Accepting Patients to the Waitlist",
      waitlist_only_tooltip: "Processing Patients on the Waitlist",
      waitlist_only: "Processing Waitlist",
      confirm_not_interested: "Not interested Update",
      confirm_ineligible: "Ineligible Update",
      confirm_not_returned: "Not returned Update",
      mark_not_interested: 'You are about to set this patient as not interested in  "{{programName}}".',
      mark_ineligible: 'You are about to set this patient as ineligible for "{{programName}}".',
      mark_not_returned: 'You are about to set "{{programName}}"as not returned for this patient.',
      cancel: "Cancel",
      remove_from_list: "Remove from List",
      remove_program: "Remove Program",
      remove_program_content:
        'You are about to remove "{{programName}}" from the patient’s list. Please note the reason.',
      remove_program_reason: "Removal reason",
      cannot_delete_with_enrollments: "This program has associated enrollments and cannot be deleted.",
      confirm: "Confirm",
      last_program_update: "Last Program Update",
      description: "Description",
      disable_tooltip: "Confirm the checkbox disclaimer to enable",
      disable_tooltip_novartis:
        "Notice the patient does not have a commercial insurance and therefore not eligible. Please update manage patient details if the patient insurance details are inaccurate.",
      // Verzenio program confirmation
      verzenio_confirmation_title: "Confirm Program Selection",
      verzenio_confirmation_message:
        "You are enrolling into the Verzenio Ongoing Support program (support only, no copay assistance). If the patient needs copay assistance, please select the Lilly Savings Card program instead - it includes both copay support and ongoing support benefits.",
      verzenio_continue_anyway: "Continue with Support Only"
    },
    renew_application_popup: {
      renew_popup_header: "Enrollment Renewal",
      renew_enrollment_content: "You are about to renew the enrollment for {{programName}}."
    },
    patientApplications: {
      enrollment_information: "Patient Enrollment Information",
      tags: "Tags",
      tags_description_1:
        "This field allows you to apply client-specific tags to track enrollment details more effectively. Tags are pre-configured during onboarding.",
      tags_description_2: "To update or add new tags, please contact Support or your Customer Success Manager.",
      tags_placeholder: "Select Tags",
      last_changed_on: "Last changed on",
      person_you_spoke_to: "Name Of Person You Spoke To",
      program_contact: "Program Contact",
      verified_with: "Verified With",
      assignee: "Assignee",
      mail_tracking_outbound: "Mail Tracking Out",
      mail_tracking_inbound: "Mail Tracking In",
      solving_conflict_failed: "Failed to solve conflict",
      enrollment_valid_through: "Enrollment Valid Through:",
      available_funds: "Available Funds:",
      application_details: "Application details",
      express_enroll_header: "Enrolling {{patientName}} in {{programName}}",
      send_enrollment: "Send Enrollment",
      not_fn_user_phi: "Downloading this form is not allowed: Must be a Financial Navigator with PHI access",
      failed_update_used_amount: "Failed to update used amount",
      prepare: "Prepare",
      applied_date: "Applied Date",
      applied: "Applied",
      applied_to_waitlist: "Applied To Waitlist",
      you_have_unsaved_application_details: "you have unsaved application details",
      approved_date: "Approved Date",
      approved: "Approved",
      canceled: "Canceled",
      expired: "Expired",
      exhausted: "Exhausted",
      denied: "Denied",
      ineligible: "Ineligible",
      not_interested: "Not Interested",
      not_returned: "Not Returned",
      missing_information: "Missing Information",
      temporarily_approved: "Temporarily Approved",
      discarded: "Discarded",
      enrollments: "All Enrollments",
      application_for: "Application for",
      status: "Status",
      last_change_by: "Last change by",
      approval_details: "Approval Details",
      program_type: "Program Type",
      potential_savings: "Potential Savings",
      used: "Used",
      approved_amount: "Approved Amount",
      max_benefit: "Max Benefit",
      zip_code: "Zip Code",
      approved_amount_required: "Approved amount is required",
      max_benefit_required: "Max benefit is required",
      approved_date_required: "Approved date is required",
      valid_through_required: "Valid through is required",
      brand_name_required: "Brand name is required",
      applied_required: "Applied date is required",
      used_amount: "Used Amount",
      update: "Update",
      edit: "Edit",
      sent_to_patient: "Sent To Patient",
      received_from_patient: "Received From Patient",
      sent_to_physician: "Sent To Physician",
      received_from_physician: "Received From Physician",
      application_id: "Application ID",
      program_name: "Program Name",
      program_sponsor: "Program Sponsor",
      waitlist_application_id: "Application Waitlist ID",
      x_months_lookback: "Program Definition - {{count}} month",
      x_days_lookback: "Program Definition - {{count}} day",
      no_lookback_period: "Program Definition - no lookback",
      lookback_period_starts: "Lookback Period Starts",
      valid_through: "Valid Through",
      indefinitely: "Indefinitely",
      valid_indefinitely: "Valid Indefinitely",
      accounting_date: "Accounting date (operation use only!)",
      cancel: "Cancel",
      save: "Save",
      member_id: "Member ID",
      valid_as_long_as: "Valid as long as the patient is in relevant active treatment.",
      manage_free_drug_orders_in_pharmacy: "Manage free drug orders in TailorMed Pharmacy",
      manage_orders_in_pharmacy: "Manage orders in TailorMed Pharmacy",
      drug_type: "Drug type",
      medication_order_type: "Medication Order Type",
      free_drug: "Free drug",
      replacement_drug: "Replacement drug",
      drug_type_required: "Drug type is required",
      medications_covered: "Medications Covered",
      free_medication: "Free Medication",
      replacement_medication: "Replacement Medication",
      bin: "BIN",
      pcn: "PCN",
      group: "Group",
      copay_card: "Copay Card",
      expiry_date: "Expiry Date",
      cvv: "CVV",
      date: "Date",
      relevant_drugs: "Relevant Drugs",
      assistance_type: "Assistance Type",
      drug_name: "Brand Name",
      no_relevant_medications: "No medications covered associated with the assistance program",
      no_other_brands: "No other medications to switch to on this assistance program",
      canceled_date: "Canceled Date",
      denied_date: "Denied Date",
      denied_reason: "Denied Reason",
      missing_information_reason: "Missing Information Reason",
      not_returned_reason: "Not Returned Reason",
      ineligible_reason: "Ineligible Reason",
      not_interested_reason: "Not Interested Reason",
      canceled_reason: "Canceled Reason",
      ineligible_date: "Ineligible Date",
      not_interested_date: "Not Interested Date",
      not_returned_date: "Not Returned Date",
      missing_information_date: "Missing Information Date",
      saving_enrollment_details: "Saving enrollment details...",
      previous_enrollment_details_summary: "Previous Enrollment Details Summary",
      click_autofill_or_fill:
        "Click on Autofill to automatically fill the application's PDF, or choose Provider Application or Pharmacy Application to fill the application online and upload the application form.",
      click_autofill: "Click on Autofill to automatically fill the application's PDF and upload the application form.",
      fill_provider: "Choose Provider Application to fill the application online and upload the application form.",
      fill_pharmacy: "Choose Pharmacy Application to fill the application online and upload the application form.",
      no_autofill_or_fill: "Autofill and Online Applications are not supported for this application.",
      click_autofill_and_provider:
        "Click on Autofill to automatically fill the application's PDF, or choose Provider Application to fill the application online and upload the application form.",
      click_autofill_and_pharmacy:
        "Click on Autofill to automatically fill the application's PDF, or choose Pharmacy Application to fill the application online and upload the application form.",
      fill_provider_and_pharmacy:
        "Choose Provider Application or Pharmacy Application to fill the application online and upload the application form.",
      autofill: "Autofill",
      diagnosis_covered: "Diagnosis Covered",
      provider_application: "Provider Application",
      pharmacy_application: "Pharmacy Application",
      application_url: "Application URL",
      patient_application_url: "Patient Application URL",
      patient_website: "Patient Website",
      generate_form: "Generate Form",
      editing_historical_application: "Editing historical application details is disabled",
      active_applications: "Active Applications",
      inactive_applications: "Inactive Applications",
      active_enrollments: "Active Enrollments",
      inactive_enrollments: "Inactive Enrollments",
      isRelevantForRenewal: "Program is set as relevant for renewal",
      isIrrelevantForRenewal: "Program is set as irrelevant for renewal",
      current_total_used_amount:
        "Current total used amount is <strong>${{usedAmount}}</strong> out of <strong>${{approvedAmount}}</strong>",
      delete_popover_text: "Delete Entry",
      amount: "Amount",
      fetch_patient_details_error: "Failed to fetch patient information for auto-filling the Express Enrollment form",
      fetch_questionnaire_error: "Failed to fetch questionnaire for the Express Enrollment form",
      additional_comments: "Additional Comments",
      additional_comments_length_error: "Maximum character limit reached. Your note must not exceed 20k characters.",
      assignee_required_error: "Assignee is required",
      validation_message: {
        application_id: "Application ID can be edited but not removed."
      },
      tabs: {
        enroll: "Enroll",
        track: "Track",
        attachments: "Attachments",
        claim: "Claim",
        order: "Order"
      },
      claims_tab: {
        all_claims: "All Claims",
        pending_claims: "Pending Claims:",
        paid_claims: "Paid Claims:",
        no_claims_yet: "No claims yet!",
        no_claims_found: "No Claims Found!",
        once_the_application_is_approved: "Once the application is approved,",
        click_buttons_below: "Click the button below to create a new claim.",
        new_claim: "New Claim",
        edit_claim: "Edit Claim",
        summery_date_of_service: "Date of Service:",
        facility: "Facility:",
        no_facility: "No Facility",
        assignee: "Assignee:",
        no_assignee: "No Assignee",
        save_claim: "Save Claim",
        general: "General",
        claim_status: "Claim Status*",
        claim_date: "Claim Date*",
        follow_up_date: "Follow‒up Date",
        payable_to: "Payable to",
        notes: "Notes",
        attachments: "Attachments",
        added_note_by: "Added by {{user}} on {{addedDate}}",
        updated_note_by: "Updated by {{user}} on {{addedDate}}",
        upload_attachment_by: "Uploaded by {{user}} on {{addedDate}}",
        delete_claim_note: "Delete Claim note",
        delete_claim: "Delete Claim",
        duplicate_claim: "Duplicate Claim",
        do_you_want_duplicate_claim: "Do you want to duplicate the claim?",
        include_notes_and_attachments: "Include notes and attachments:",
        delete_claim_attachment: "Delete Claim Attachment",
        last_updated: "Last saved {{updatedDate}} ",
        by_user: " by {{user}}",
        are_you_want_delete_note: "Are you sure you want to delete this note?",
        are_you_want_delete_claim: "Are you sure you want to delete this claim?",
        are_you_want_delete_attachmente: "Are you sure you want to delete {{fileName}}?",
        medication_service_information: "Medication / Service Information",
        choose: "Choose",
        select_medication: "Select medication",
        enter_item: "Enter item",
        enter_code: "Enter code",
        at_least_one_item: "To save, enter at least one line item for this claim.",
        amount_required: "Amount Required",
        error_message: {
          get_claim_attachments: "failed to get claim attachments",
          attachment_upload_failed: "Attachment upload failed - file size exceeds {{maxSize}} max.\n Please try again.",
          get_claim_notes: "failed to get claim notes",
          failed_to_get_orders: "Failed to get orders",
          only_numbers_and_letters: "Numbers / letters only",
          only_numbers: "Numbers only",
          assignee_required_error: "Assignee is required",
          unsaved_changes: "Unsaved Changes"
        },
        popover: {
          pending: "Pending: ",
          pending_claim: "Claim has not yet been submitted to the program sponsor",
          submitted: "Submitted: ",
          submitted_claim: "Claim has been submitted to the program sponsor",
          paid: "Paid: ",
          paid_claim: "Full or partial payment has been received",
          denied: "Denied: ",
          denied_claim: "Claim was denied in full",
          medical: "Medical: ",
          medical_claim: "Typically administered at providers' office and billed through the patient’s medical benefit",
          pharmacy: "Pharmacy: ",
          pharmacy_claim:
            "For medications dispensed through pharmacy and billed through the patient’s pharmacy benefit",
          pending_payment: "Pending Payment: ",
          pending_payment_claim: "Claim was approved by the program sponsor and is now awaiting payment",
          oop: "OOP Max Met: ",
          oop_claim: "Patient met their OOP and no longer needs reimbursement from assistance program"
        },
        constant_lists: {
          pending: "Pending",
          submitted: "Submitted",
          paid: "Paid",
          denied: "Denied"
        },
        date_of_service_input_label: "Date of Service*",
        account_number: "Account Number",
        add_claim_note: "Add claim note",
        size_per_file: "15MB per file",
        upload_claim_attachment: "Upload claim attachment",
        type: "Type*",
        treatment_service: {
          text: "Medication / Service",
          pop_up_content:
            "For <bold>copay foundation</bold> applications, select the patient's <bold>relevant drugs</bold> from the <bold>Track</bold> tab when approving the application to see them here."
        },
        service_code: "Service Code",
        amount: "Amount*",
        total: "Total",
        add_new_item: "Add new item",
        date_submitted: "Submitted Date",
        payment_information: "Payment Information",
        paid: "Paid",
        claim_is_processing: "Claim is Processing....",
        please_wait_while_we_save_the_claim: "Please wait while we save the claim",
        denied: "Denied",
        patient_responsibility: "Patient Responsibility",
        pr: "PR",
        balance: "Balance",
        amount_greater_requested: "Amount entered is greater than the requested amount.",
        received_date: "Posted Date*",
        approved_date: "Approved Date",
        denied_date: "Denied Date*",
        payment_type: "Payment Type",
        select_payment_type: "Select payment type",
        check_number_ach: "Check number / ACH",
        enter_number: "Enter number",
        filter_by_claim_status: "Filter by claim status:",
        actions_menu: {
          edit: "Edit",
          duplicate: "Duplicate",
          delete: "Delete",
          restore: "Restore"
        },
        alert_max_character: "Maximum character limit reached. Your note must not exceed 250 characters.",
        add_note: "Save Note",
        enter: "Enter",
        to_manage_free_drug_orders: "To order free drugs for your patient, go to pharmacy.",
        go_to_pharmacy: "Go To Pharmacy",
        to_order_free_drug: "To order free drugs for your patient, use the link to go to pharmacy.",
        upgrade_required: "Upgrade required. Contact your customer success manager to get started.",
        no_orders_yet_once_the_application_is_approved:
          "No orders yet! Once the application is approved, go to pharmacy to manage free drug orders for your patient.",
        statuses: {
          titles: {
            order_required: "Order Required",
            in_transit: "In Transit",
            in_pharmacy: "In Pharmacy",
            drug_dispensed: "Drug Dispensed",
            drug_billed: "Drug Billed"
          },
          actions: {
            ordered: "Mark as Ordered",
            arrived: "Mark as Arrived",
            dispensed: "Mark as Dispensed",
            done: "Mark as Done"
          }
        },
        error_messages: {
          notes_length_error: "Maximum\ncharacter\nlimit\nreached"
        },
        notes_section: {
          notes: "Notes",
          add_a_new_note: "Add a new note",
          save_note: "Save Note",
          cancel: "Cancel",
          no_notes_yet: "No notes yet.",
          start_by_typing_in_the_box_above: "Start by typing in the box above.",
          edit_note_placeholder: "Edit note",
          save: "Save",
          save_changes: "Save Changes",
          discard_changes: "Discard Changes",
          unsaved_changes: "Unsaved Changes",
          unsaved_changes_message:
            "You’ve made changes to your note. If you leave now, your unsaved edits will be lost.\n\n Do you want to stay and save your changes?"
        }
      },
      enroll: {
        digital_signature: {
          enrollment_header: "Enrollment Form",
          incomplete_enrollment_description: "Click the open editor button to fill out the Enrollment Form.",
          open_editor: "Open Editor",
          delete_pdf: {
            no_signatures_title: "Delete PDF",
            no_signatures_message_content: "You are about to delete the pdf file.\n\nAre you sure you want to do this?",
            pending_signatures_title: "Delete PDF & revoke signatures Requests ",
            pending_signatures_message_content:
              "You are about to delete the pdf file.\nAll signatures pending or signed will be lost.\n\n\nAre you sure you want to do this?",
            with_signatures_message_title: "Delete signed PDF ",
            with_signatures_message_content:
              "You are about to delete the pdf file.\nAll signatures pending or signed will be lost.\n\n\nAre you sure you want to do this?",
            delete_error_message_pdf: "Enrollment form failed to delete.",
            delete_error_message_pending_signatures_pdf: "Enrollment form & signature request failed to delete.",
            delete_success_message_pdf: "Enrollment form deleted successfully",
            delete_success_message_pending_signatures_pdf: "Enrollment form & signature request deleted successfully"
          },
          last_changed: "Last changed on {{signatureSignDate}}",
          upload_pdf: "Upload PDF",
          upload_pdf_step_content:
            "Upload the completed pdf (not a scanned copy) to proceed to the digital signatures step, or alternatively skip and upload an already signed form for bookkeeping.",
          upload_to_esign: "Upload to SmartSign",
          requires_wet_signature:
            "This application requires wet signatures; digital signatures are not accepted by the sponsor.\n Optionally, you can upload the signed form for bookkeeping in TailorMed.",
          skip_and_upload_a_signed: "Skip & Upload a Signed Form",
          upload_a_signed: "Upload a Signed Form",
          upload_the_signed_form_for_bookkeeping:
            "Optionally, you can upload the signed form for bookkeeping in TailorMed.",
          alarm_message_cant_add_digital_signatures:
            "We can’t add digital signatures to scanned or unrecognized PDFs. To use SmartSign in step 3, delete the pdf and restart.",
          wet_signer_step_title: "Wet Signature",
          wet_signer_description:
            "To complete the enrollment form, This application requires wet signature from your {{signerType}}; digital signature are not accepted.",
          wet_signature_widget: {
            signed_by: "Wet signature was signed \n by {{signerType}} {{name}} on \n {{date}}",
            reupload_signed_form: "Re-upload a signed form",
            wet_signature_widget_initial_description: "Please print the PDF and upload it once it has been signed.",
            print: "Print",
            upload_signed_form: "Upload a signed form",
            reupload_modal_title: "Re-upload a signed form will Remove \nSignature From Form",
            reupload_modal_description:
              "The signature will be removed from the enrollment form. \n\n Are you sure you want to do this?"
          },
          enrollment_form_finished: "Enrollment Form Finished",
          please_download_or_print_the_pdf: "Please download or print the PDF to submit the signed Enrollment Form.",
          download: "Download",
          print: "Print",
          not_allowed_message: "{{actionName}} is not allowed: must be a Financial Navigation with phi access."
        },
        enrollment_form: {
          header: "Enrollment Form",
          headerForNovartis: "Enrollment Information",
          description: "Click the button to complete the Enrollment Form",
          descriptionForEEWithESign: "Click the Open Editor button to fill out the Enrollment Form.",
          description_one_step: "Click the Prepare button to fill out and submit the Enrollment Form",
          edit_button: "Edit Form",
          delete_button: "Delete",
          prepare_button: "Prepare",
          open_editor_button: "Open Editor",
          continue_button: "Continue Editing",
          prepare_and_submit_button: "Prepare and Submit",
          edit_and_submit_again_button: "Edit and Submit Again",
          save_success_message: "Application form was saved successfully",
          save_draft_success_message: "Enrollment Form was saved to Draft",
          save_error_message: "There was an issue saving the application form",
          autosubmit_error_message: "The application was already signed. Please refresh.",
          no_access_tooltip: "The user have no permission to see the data.",
          generate_success_message:
            "Enrollment Form was generated successfully. Next Step is available - Get E-Signatures",
          generate_error_message: "There was an issue generating the enrollment form",
          continue_editing: "Continue Editing"
        },
        electronic_signatures: {
          titles: {
            signature_type: "Signature Type",
            required_full_name: "Full Name *",
            required_send_by_email: "Send by Email *",
            send_by_sms: "Send by SMS",
            phone_number: "Phone Number",
            date: "Date",
            role: "Role",
            status: "Status"
          },
          genentech_free_drug: {
            description:
              "This application requires Prescriber’s Consent. Use the options on the right to upload<br/> a signature image (JPG or PNG), or to request a digital signature via DocuSign.",
            secondary_description:
              "Fill in the missing details to enable sending the cover letter to the prescriber via DocuSign to provide their electronic signature.",
            info_section_description:
              "<div><bold>Prescription Requirements</bold></div><div>An eSigned Prescriber Foundation Form cannot be used as a prescription for upfront shipments. To submit a valid prescription you can:<br>Provide a verbal prescription to our specialty pharmacy by calling (833) 888-4363, Fax a prescription with a “wet” signature to (833) 999-4363<br>Submit an ePrescription to: MedVantx (AmeriPharm), NCPDP/NABP: 4351968, NPI: 1073692745, If you have questions please contact Access Solutions at (866) 422-2377.</div>"
          },
          prescriber: "Prescriber",
          edit: "Edit",
          cancel_docusign: "Cancel Docusign",
          cancel_signature: "Cancel Signature",
          docusign: "DocuSign",
          patient_recipient_one: "Patient (Recipient 1)",
          physician_recipient_two: "Physician (Recipient 2)",
          physician: "Physician",
          sender: "Sender",
          header: "Signatures",
          description:
            "Send the filled Enrollment Form to the required parties for E - Signature or upload a signed PDF form",
          signature_sent: "Signature Request was sent to recipients on {{signatureSentDate}}",
          signature_signed: "Signature Request was signed on {{signatureSignDate}}",
          signature_uploaded: "Signature was uploaded on {{signatureSignDate}}",
          get_signatures_button: "Get E-Signatures",
          get_signature_button: "Get E-Signature",
          upload_signed_form_button: "Upload Signed Form",
          upload_signature_button: "Upload Signature",
          send_via_docusign_button: "Send Via DocuSign",
          secondary_description_bold: "Send for e-signature - ",
          secondary_description:
            "Fill in the missing details to enable sending signature request to the recipients by email & SMS",
          sender_header: "Sender",
          view_request_button: "View Request",
          close: "Close",
          email_to_recipient:
            "The email will arrive to recipient's mailbox and might be marked as spam.\nYou will receive an email once all recipients have signed",
          cancel: "Cancel",
          mark_as_signed: "Mark as signed",
          mark_as_signed_warning: "Mark as signed to submit the form",
          placeholders: {
            send_by_phone: "(000) 000-0000",
            email: "name@gmail.com",
            full_name: "Enter Full Name"
          },
          status: {
            unsigned: "Unsigned",
            pending: "Pending Signatures",
            signed: "Signed",
            draft: "Draft"
          },
          success: "The signature request was sent successfully",
          tooltip:
            "The Sender details are mandatory\nEmails will be used for notification after signature completion\nPhone will be presented to the patient as contact details.",
          modal: {
            cancel_docusign_title: "Cancel DocuSign",
            cancel_docusign_description_sign:
              "This action will reset the consent request.\nAll signatures pending or signed will be lost.\n\n\nAre you sure you want to do this?",
            cancel_request_title: "Cancel Signature Request",
            cancel_request_description_before_sign:
              "You are about to cancel the signature request.\nThis action will notify the recipients by email. The PDF will not be available for signatures anymore.\n\nAre you sure this is what you want to do?",
            cancel_request_description_after_sign:
              "You are about to cancel the signature request.\nSince the document was signed by all recipients, a notification will NOT be sent.\n\nAre you sure this is what you want to do?",
            cancel_signature_title: "Cancel Signature",
            cancel_signature_description:
              "You are about to cancel the current signature.\n\nAre you sure this is what you want to do?",
            delete_signature_title: "Delete Signature",
            delete_signature_description:
              "You are about to delete the current signature.\n\nAre you sure this is what you want to do?",
            yes_sure: "Yes, I'm Sure",
            cancel: "No",
            delete_form_title: "Delete Enrollment Form",
            reset_form_tile: "Reset Form",
            cancel_form_title: "Cancel Signature",
            delete_form_description:
              "You are about to delete the enrollment form.\n- This action will initialize the entire enrollment process.\n- The data entered in the enrollment form will be saved and pre-populated the next time you prepare the form.\n\nAre you sure this is what you want to do?",
            reset_form_description:
              "This action will reset the patient consent.\nAll signatures pending or signed will be lost.\n\n\n\nAre you sure you want to do this?",
            close_form_title: "Close Enrollment Form",
            close_form_description:
              "You are about to close the enrollment form - the data entered in the enrollment form will not be saved.\n\n\nAre you sure this is what you want to do?",
            upload_signature_confirmation_modal_title: "Upload a Signature Image",
            choose_image_file: "Choose Image File",
            consent_for_signature_use: "Consent for Signature Use",
            save_signature_for_future: "Save Signature for Future Use",
            consent_signature_confirmation_text:
              "I confirm that I have obtained the physician's explicit consent to use their signature image on financial assistance enrollment forms for the purpose of submitting patients to financial assistance programs.",
            save_signature_confirmation_text:
              "Save the physician’s signature in TailorMed Financial Navigation, to be used by you or your team in future enrollments for this or other patients."
          },
          errors: {
            send_signature_error: "There was an issue sending the signature request",
            send_signature_phone_error:
              "The DocuSign request can't be sent to {{phoneNumber}} due to lack of SMS consent. Please use Email or update the contact number.",
            same_emails_error: "Use a different email",
            upload_error: "File upload failed. Please try again.",
            send_signature_invalid_phone_error:
              "There was an issue sending the signature request - phone number {{phoneNumber}} is invalid."
          },
          signature_step: {
            signers: {
              patient: "Patient",
              physician: "Physician",
              hcp: "HCP",
              caregiver: "Patient / Caregiver"
            },
            status: {
              pending: "Pending Signature",
              signed: "Signed",
              expired: "Link Expired",
              not_started: "Not Started"
            },
            signature_options: {
              fill_now: "Fill Now",
              request_signature: "Request Signature"
            },
            request_signature_data: { email: "Email", sms: "SMS" },
            action_buttons: {
              remove: "Remove",
              cancel: "Cancel",
              submit: "Submit",
              save: "Save",
              request: "Request",
              resend_request: "Resend",
              send_reminder: "Send Reminder",
              revoke: "Revoke",
              upload_image: "Upload Image",
              revoke_modal_title: "Revoke Signature Request",
              remove_modal_title: "Remove Signature From Form",
              revoke_modal_description:
                "You are about to revoke the signature request.\nThe link sent to the signee will expire.\n\n Are you sure you want to do this?",
              remove_modal_description:
                "The signature will be removed from the enrollment form.\n\n Are you sure you want to do this?",
              draw: "Draw",
              use_saved_signature: "Use Saved Signature",
              draw_again: "Draw again",
              upload_a_new_image: "Upload a new image",
              reload_signature: "Please refresh to see status updates"
            },
            upload_modal: {
              title: "Upload a Signature Image",
              consent_title: "Consent for Signature Use",
              consent_text:
                "I confirm that I have obtained the physician's explicit consent to use their signature image on financial assistance enrollment forms for the purpose of submitting patients to financial assistance programs.",
              choose_file_button: "Choose Image File",
              choose_different_button: "Choose Different File",
              confirm_button: "Confirm Upload",
              simulation_title: "Signature Preview",
              simulation_description: "This is how your signature will appear on the form.",
              bad_example_label: "Entire form",
              good_example_label: "Signature only",
              guide_image_loading_aria_label: "Loading signature upload guide...",
              guide_image_alt: "Signature upload guide - upload only the signature, not the entire form"
            },
            save_signature_checkbox: "Save my signature in TailorMed system",
            messages: {
              expiration_warning_days: "Request expires automatically in {{days}} {{dayLabel}}.",
              expiration_warning_hours: "Request expires automatically in {{remaining}} hours.",
              expiration_warning_days_hours:
                "Request expires automatically in {{remaining}} {{days}} {{dayLabel}} and {{hours}} {{hourLabel}}.",
              expiration_warning_one_hour: "Request expires automatically in less than one hour.",
              send_request_email: "Please send signature request via email.",
              send_request_sms_and_email: "Please send signature request via email and/or SMS.",
              please_verify_email: "Please verify that the email address is correct.",
              missing_dob: "Missing Patient Date of Birth. DOB is used to authenticate the patient when signing. ",
              missing_caregiver_name: "Missing information. Please add Caregiver name. ",
              missing_patient_name: "Missing information. Please add Patient name. ",
              missing_email_and_phone: "Missing information. Please add email and phone number. ",
              missing_email: "Missing information. Please add email. ",
              missing_phone: "Missing information. Please add phone number. ",
              patient_data_changed:
                "Please note that the patient details have been updated. You can revoke the signature and request it again. ",
              please_verify_details: "Please verify that the details are correct. ",
              missing_info_link: "<br/>Please add in <a>Manage Patient Details</a> section.",
              signature_revoked_success: "Signature was revoked successfully",
              signature_removed_success: "Signature was removed successfully",
              signature_revoked_error: "Failed to revoke signature",
              signature_revoke_signed_error: "The revoke action failed because the PDF has already been signed.",
              signature_send_reminder_signed_error:
                "The send reminder action failed because the PDF has already been signed.",
              signature_remove_error: "Failed to remove signature",
              request_email_bounce_error:
                "The email has bounced, please check the details and request again. If the problem persists please contact support",
              success: {
                request: "Request was sent successfully",
                reminder: "Reminder was sent successfully",
                fill_now_success: " Signature successfully populated in the application form",
                save_signature_success: "Signature was saved in TailorMed.",
                populate_saved_signature_success: "Signature successfully populated in the application form."
              },
              errors: {
                general_error: "Something went wrong. Please try again.",
                technical_error:
                  "Something went wrong due to technical reasons.\nplease check the details and request again. If the problem persists please contact support.",
                request: {
                  sms: "Email was sent successfully. SMS has failed to send. You can continue using email as usual.",
                  email: "SMS was sent successfully. Email has failed to send. You can continue using SMS as usual."
                },
                single_channel_request: {
                  email:
                    "Email has failed to send. Please check the email address and request again. If the problem persists please contact support.",
                  sms: "SMS has failed to send. Please try again. If the problem persists please contact support."
                },
                reminder: {
                  sms: "Email reminder was sent successfully. SMS reminder has failed to send. You can continue using email as usual.",
                  email:
                    "SMS reminder was sent successfully. Email reminder has failed to send. You can continue using SMS as usual."
                },
                fill_now_draw_failed: "Add signature failed. Please try again.",
                fill_now_upload_failed: "Attachment upload failed. Please try again.",
                fill_now_image_size_error:
                  "Attachment upload failed - file size exceeds {{maxSize}} MB max. \nPlease try again.",
                populate_save_signature_error: "Signature was not populated in the application form. Please try again.",
                save_signature_error: "Signature was not saved in TailorMed. Please try again.",
                reload_signature_error: "Couldn’t refresh signature status. Please try again."
              },
              warnings: {
                saved_signatures_warning:
                  "Ensure the enrollment form permits saved or uploaded signatures. Do not use this feature if the form explicitly prohibits stamps or digital reproductions of signatures."
              }
            },
            caregiver: "Caregiver",
            caregiver_name: "Caregiver Name",
            patient_name: "Patient Name",
            or: "OR",
            singed_info: "Signed Info",
            sent_on: "Sent on {{date}}",
            signature_completed_by: "Signature completed by <span>{{name}}</span> on {{date}}",
            reminded_at: "Reminder sent on {{date}}",
            fill_now_upload: "Upload a jpg/png image of the {{title}}’s <span>{{name}}</span> signature",
            fill_now_upload_saved_signature: "Use the {{title}}’s <span>{{name}}</span> saved signature",
            fill_now_draw: "If authorized, draw your \nsignature with the cursor",
            fill_now_draw_saved: "Use my saved signature, \nor draw again",
            smart_sign: "SmartSign",
            allSignatures: "Signatures",
            description_hcp:
              "To complete the enrollment form, this application requires a Health Care Professional (HCP) signature",
            description_physician:
              "To complete the enrollment form, this application requires the patient's physician signature.",
            description_caregiver:
              "To complete the enrollment form, this application requires the patient's or caregiver signature.",
            description_patient: "To complete the enrollment form, this application requires the patient's signature.",
            description_hcp_with_caregiver:
              "To complete the enrollment form, this application requires a Health Care Professional (HCP) and the patient's or caregiver signature.",
            description_hcp_with_patient:
              "To complete the enrollment form, this application requires a Health Care Professional (HCP) and the patient's signature.",
            description_physician_with_caregiver:
              "To complete the enrollment form, this application requires the patient's physician and the patient's or caregiver signature.",
            description_physician_with_patient:
              "To complete the enrollment form, this application requires the patient's physician and the patient's signature.",
            description_instruction:
              "<br/>Use the options below to add or request digital signatures, or skip & upload a signed form instead.",
            regeneron_copay_description_patient: "This application requires the prescribing physician’s consent.",
            regeneron_pap_description_physician_with_patient:
              "This application requires the consent of the prescribing physician and the patient or patient's caregiver.",
            genentech_pap_description_physician:
              "This application requires the prescribing physician’s consent. Use the options below to either upload the image of the signature, or to send a request to the physician.",
            ee_description_patient: "This application requires the patient's consent.",
            ee_submit_automatically:
              "Automatically submit the application when the signature is complete.\nYou will get a confirmation email once it's submitted.",
            signature_pad_title: "Draw your signature",
            signature_pad_clear: "Clear",
            signature_pad_button_text: "Add To Form",
            signature_pad_modal_title: "Add Signature",
            signature_pad_not_clear_error: "Signature not clear enough. Please try again",
            signature_pad_modal_description:
              "Draw your signature in the designated area below. Adding the signature will \n automatically insert it into the enrollment form.",
            genentech_pap_info_section:
              "<div>This Express Enroll process does not support uploading a signed form. If using a downloaded PDF, extract the physician’s signature by taking a screenshot <br/>(JPG or PNG) and upload it using the Upload Image button. <br/>Please note: If you submit via fax or the manufacturer portal, you must also collect a patient’s signature.</div>"
          }
        },
        application_form_submission: {
          eagle_pemfexy: {
            description: "Send the signed Enrollment Form and attachments by eFax to the manufacturer",
            submit_button: "Submit with eFax",
            submit_success_message: "Submission using eFax is in process for TM-{{patientId}}.",
            submit_in_progress:
              "Application was submitted to the manufacturer on {{submitDate}}. <strong>Submission using eFax is in process.</strong><br/>Once a response is received you will get an email."
          },
          eSign: {
            description: "Submit enrollment to the manufacturer."
          },
          genentech_free_drug: {
            description: "Click Submit to send the application to the manufacturer.",
            submit_completed: "The application was submitted to the Manufacturer on {{submitDate}}.",
            gpf_modal: {
              title: "GPF Now Requires Supporting Documents",
              body: "If your patient has health insurance or has received a coverage denial, please fax the front and back of the insurance card, denial documents, and any other supporting documentation directly to Genentech Patient Foundation at",
              fax_number: "833-999-4363"
            }
          },
          header: "Enrollment Form Submission",
          description: "Send the signed Enrollment Form and attachments to the manufacturer",
          submit_button: "Submit",
          close_button: "Close",
          submit_in_progress:
            "Enrollment Form was submitted on {{submitDate}}. Once a response is received you will get an email.",
          submit_completed: "Application was submitted to the manufacturer on {{submitDate}}.",
          submit_completed_novartis: "Enrollment form was submitted on {{submitDate}}.",
          submit_succeeded_without_date:
            "Enrollment Form was submitted. Once a response is received you will get an email.",
          submit_failed_with_date:
            "Application was submitted to the manufacturer on {{submitDate}}. <strong>Submission failed, please try again.</strong>",
          auto_submit_failed_with_date:
            "Application was submitted automatically to the manufacturer on {{submitDate}}. <strong>Submission failed, please try again.</strong>",
          submit_succeeded_automatic: "Enrollment Form was submitted on {{submitDate}}.",
          auto_submit_succeeded: "Submitted automatically by the system on {{submitDate}}.",
          submit_succeeded_without_date_automatic: "Enrollment Form was submitted.",
          view_details: "View Details",
          submit_success_message: "Application was submitted successfully.",
          auto_submit_tooltip: "The application is being automatically submitted to the manufacturer.",
          submit_modal: {
            title: "Submit",
            description:
              "You are about to submit the application. Please make sure all the relevant documents are attached",
            description1: "You are about to submit the application.",
            application_form_divider: "Application Form",
            files_size_exceed_max:
              "The total size of all files should not exceed {{maxSize}}. Please check the 'Attachment' tab and update the files as needed.",
            attachments_divider: "Additional Attachments",
            attachments_divider_brackets: "(supporting PDF format only)",
            cancel_button: "Cancel",
            generic_error_message: "Enrollment Form Submission failed, Please try again.",
            attachments_error_message: "Loading Attachments failed, Please try again",
            remove_attachment_tooltip: "Remove from application submit",
            steps_information:
              "<div>PLEASE NOTE: An eSigned Prescriber Foundation Form cannot be used as a prescription for upfront shipments. To submit a valid prescription you can: <br>Provide a verbal prescription to our specialty pharmacy by calling (833) 888-4363, Fax a prescription with a “wet” signature to (833) 999-4363 <br>Submit an ePrescription to: MedVantx (AmeriPharm), NCPDP/NABP: 4351968, NPI: 1073692745, If you have questions please contact Access Solutions at (866) 422-2377.</div>",
            submit_information:
              "<div><p>A valid prescription must be received before a determination of assistance can be made as this is a requirement for program enrollment.</p><p>An e-signed enrollment form is <bold>not a valid prescription.</bold> In order for your patient to be considered for assistance, <bold>a valid prescription is required and must be submitted at the time of enrollment request</bold> in one of two ways:</p><p>Option 1: Submit a paper prescription with an ink signature, either by faxing it to 1-877-736-6506 or by attaching a scanned copy to the application.</p><p>Option 2: E-prescribe to AmeriPharm (NPI number–1073692745; NCPDP number–4351968) or MedVantx (NPI number–1235371535; NCPDP number– 4354180). <bold>New York prescribers must e-prescribe.</bold></p><span>"
          },
          processing_modal: {
            title: "Processing the Application....",
            description: "This may take around 2 minutes.",
            error: "There was an issue getting the application status. Please try again."
          },
          view_submitted_modal: {
            title: "View Submitted Application  ",
            description: "The application form includes the Enrollment Form and all attachments",
            close: "Close"
          },
          fetching_application_form_error_after_submit:
            "Successfully submitted Enrollment Form. Failed to update Application Form information",
          fetching_application_form_error: "Failed to update Application Form information",
          fetching_express_enrollment_error_after_submit:
            "Successfully submitted Enrollment Form. Failed to update Enrollment Form Submission information",
          fetching_application_error_after_submit:
            "Successfully submitted Enrollment Form. Failed to update Application information"
        },
        enroll_result: {
          download_saving_card: "Download Savings Card",
          application_approved_for: "Application Submitted And Approved\nFor {{items}}",
          application_denied_for: "Application Submitted And Was Denied\nFor {{items}}",
          application_submitted_for: "Application Submitted \nFor {{items}}",
          application_failed_for: "Application Submission Failed For Drug {{items}}",
          application_failed: "Application Submission Failed",
          contact_genentech_error: "<span>Please contact Genentech’s Helpdesk at 855-692-6729.<span>",
          admin_only: "Admin {{drug}}",
          drug_and_administration: "{{drug}} (Drug and Administration)",
          drug: "Drug {{drug}}",
          drugs: "Drugs {{drugs}}",
          application_approved_subtitle:
            "In the next few days, a welcome letter will be mailed to the patient’s address provided under the “Patient” section. The letter has information about the program and instructions for how to use it.",
          application_approved_assign_debitcard_text:
            "You can retrieve the 16-digit virtual card number from the program portal or by calling {{phone}}",
          application_denied_subtitle: "<span><bold> Denial reason: </bold> {{denialReason}}<span>",
          application_denied_rejected_id_subtitle:
            "<span><bold> Genentech is still processing the request.</bold><span>",
          contact_customer_service: "<span> Please call <bold>{{phoneNumber}}</bold> for further assistance<span>",
          more_information_required: "<span> More information may be required.</span>",
          confirmation_id: "<span><bold> Reference Number: </bold> {{confirmationId}}<span>",
          unknown_denial_reason: "Unknown reason.",
          patient_status: "Patient Status: ",
          member_id: "Member ID: ",
          enrolled_programs: "Enrolled Program(s): ",
          rxbin: "RxBIN: ",
          group_number: "Group Number: ",
          pcn: "PCN: ",
          application_id: "TailorMed Application ID: ",
          card_activation_date: "Card Activation Date: ",
          card_end_date: "Card End Date: ",
          bin: "BIN: ",
          activationDate: "Activation date: ",
          total_grant_amount: "Total Grant Amount: ",
          details_saved: 'All details are saved and can be viewed on the application’s "Track" tab.',
          call_support: "If you have any questions, please call {{phone}}.",
          contact_support: "If technical support is needed - please contact ",
          contact_support_tech: "If technical help is required - please contact ",
          contact_time_bms:
            "If you have any questions, please call 1-888-768-9588, Monday–Friday, 8 AM–8 PM Eastern time.",
          contact_time_regeneron:
            "If you have any questions, please call LIBTAYO Surround at 1.877.LIBTAYO (1.877.542.8296) Option 1, Monday–Friday, 8 AM–8 PM Eastern time.",
          log_reason: "Please don’t forget to include the above failure log reason.",
          contact_support_with_error: "Contact Support at ",
          dont_forget_to_include_error: ". Please don’t forget to include the above failure reason.",
          failed_to_get_submit_result: "Failed to Get Submit Result",
          failure_reason: "Failure reason: ",
          practice_not_registered:
            "The practice's NPI information is not registered on the Pfizer Co-pay portal. Please confirm the NPI details and resubmit. For further assistance, call Pfizer Patient Support at 800-555-4820 if needed.",
          patient_is_already_enrolled:
            "The patient you are trying to enroll is already enrolled into the program. For assistance, please contact Pfizer Patient Support at 800-555-4820.",
          patient_has_government_insurance:
            "Enrollment is not possible for this patient due to government insurance eligibility. Please verify the insurance details and attempt to resubmit the enrollment.",
          request_id: "Request ID: ",
          npi_associated_to_portal: "NPI Associated to Portal: ",
          please_try_to_resubmit_the_application: "Please try to resubmit the application.",
          track_tab_info: 'All details are saved and can be viewed on the application\'s "Track" tab',
          application_success: "Application Submitted and Approved for {{item}}",
          application_success_no_drugs: "Application Submitted and Approved",
          application_denial: "Application Denied for ",
          application_error: "Application Submission Failed for {{item}}",
          application_error_multi: "Application Submission Failed for {{item1}} and {{item2}}",
          denial_reason: "Denial reason: ",
          group: "Group: ",
          pfizer_copay_oral_failure_massage: "Please contact the Help Desk TFN line 1-800-337-9539",
          awarded_amount: "Awarded Amount: ",
          expiration_date: "Expiration Date: ",
          lilly_support_enrollment_message:
            "Enrolled for Verzenio ongoing support program, \na member of Lilly Support Services™ will contact the patient",
          lilly_patient_already_enrolled:
            "The patient has an existing copay card, please contact the patient or ask them to contact the copay vendor Paysign: +{{phoneNumber}}",
          copay_card_approved: "Copay Card Approved"
        },
        editFileWarningModal: {
          header: "Save & Download will Create New Enrollment Form",
          body: "You are about to edit the pdf file. <br> <ul> <li>All signatures pending or signed will be lost.</li> <li>However, any data previously edited in the enrollment editor will be saved in the editor, and pre-populated the next time you generate the pdf.</li> </ul><br> Are you sure you want to do this?"
        },
        unsupportedPDFModal: {
          header: "Unsupported PDF Uploaded",
          body: "We are unable to digitally sign scanned or unrecognized PDFs.\n Please upload a non-scanned PDF for digital signature. Alternatively, you can skip this step and upload a signed document, scanned or not.",
          close: "Close"
        },
        uploadToSignWarning: {
          header: "Upload to SmartSign",
          body: "Uploading form will:<br> <ul> <li>Override the pdf </li> <li>All signatures pending or signed will be lost </li></ul><br> Are you sure you want to do this?"
        },
        skipAndUploadSignedWarning: {
          header: "Skip & Upload a Signed Form",
          body: "Uploading form will:<br> <ul> <li>Override the pdf </li> <li>All signatures pending or signed will be lost </li><li>Disable the option to add digital signatures</li></ul><br> Are you sure you want to do this?"
        },
        applicationStatusChangeWanning: {
          header: "Change in Status",
          body: "There are signature requests pending, changing the status will revoke them.<br> <br> Are you sure you want to proceed?"
        }
      },
      used_amount_modal: {
        delete_confirm_modal: {
          title: "Delete Used Amount",
          content: "This action will delete the Used Amount - Are you sure you want to proceed ?"
        },
        add_entry: "+ Add Entry",
        failedToUpdateMessage: "Failed to update Used Amount rows",
        updatedSuccessfullyMessage: "Used amounts we're updated successfully",
        usedAmountExceededMessage: "Exceeding approved amount",
        usedAmountExceededMessage_max_benefit: "Exceeding max benefit",
        missingUsedAmountText: "Missing Used Amount",
        missingDateText: "Missing Date"
      },
      applicationsTable: {
        name: "Name",
        id: "Id",
        status: "Status",
        approved: "Approved",
        valid_through: "Valid Through",
        last_updated: "Last Updated",
        renewal_actions: "Renewal Actions",
        claim_amounts: "Claim Amounts",
        claim_actions: "Claim Actions",
        total_paid_pending_amount: "Total Paid Amount | Pending Amount",
        total_paid_amount: "Total Paid Amount: ",
        sum_of_all_paid_amounts: "Sum of all paid amounts for claims received",
        pending_amount: "Pending Amount: ",
        sum_of_all_requested_amounts: "Sum of all requested amounts for pending, submitted and pending payment claims",
        add_new_claim: "Add new claim",
        actions: {
          renew: "Renew enrollment",
          setAsIrrelevant: "Set as irrelevant for renewal",
          setAsRelevant: "Set as relevant for renewal",
          delete: "Delete",
          set_irrelevant_for_renewal_popup_header: "Removing from Renewal List",
          set_irrelevant_for_renewal_popup_content:
            'You are about to set "{{applicationName}}" as irrelevant for renewal for this patient.',
          set_relevant_for_renewal_popup_header: "Set enrollment as relevant",
          set_relevant_for_renewal_popup_content:
            'Are you sure you want to set "{{applicationName}}" as relevant for renewal for this patient?\nIt will be tracked in "Pending Renewal" list, when relevant.',
          delete_enrollment_content:
            "You are about to permanently delete the enrollment for {{applicationName}} and all its associated information and attachments.\n\n",
          delete_enrollment_title: "Enrollment Deletion",
          disable_delete_application_funds_management_approved:
            "This enrollment is managed in Funds Management and can’t be deleted.",
          disable_delete_application_used_amount: "The application has reported used amount, so it can not be deleted.",
          disable_delete_enrollment_reported_claims:
            "This enrollment has reported claims and cannot be deleted. Remove any associated claims and try again.",
          disable_delete_enrollment_pharmacy_patient:
            "This enrollment has an associated pharmacy patient and cannot be deleted.",
          this_enrollment_cannot_be_deleted: "This enrollment cannot be deleted."
        }
      },
      autoFillModal: {
        title: "Configure Auto-Filled Application Form",
        subHeaderText: "Please select specific configuration for the below form fields:",
        cancel: "Cancel",
        save_and_download: "Save & Download",
        patientUninsured: "Patient is uninsured",
        selectNameInsteadOfFN: "Use selected physician name instead of FN team name for shipping details",
        editPhysician: "Edit Physician information",
        closePhysician: "Close Physician information",
        editFacility: "Edit Facility information",
        closeFacility: "Close Facility information",
        editRxInsurance: "Edit RX insurance",
        closeRxInsurance: "Close RX insurance",
        pharmacy_benefit_insurance: "Pharmacy Benefit Insurance Exists?",
        insurance_part_D: "Is this a Part D plan?",
        cancel_modal_title: "Unsaved Form Details",
        placeholder: {
          shipmentRecipient: "Shipment / recipient information",
          physicianInformation: "Physician information",
          facilityInformation: "Facility information",
          diagnosisInformation: "Diagnosis information",
          primaryCoverage: "Primary coverage",
          secondaryCoverage: "Secondary coverage",
          associatedDrug: "Associated drug",
          selectPhysician: "Select a physician",
          selectFNTeam: "Select FN team",
          name: "Name",
          firstName: "First Name",
          middleName: "Middle Initial",
          lastName: "Last Name",
          dob: "Date of Birth",
          gender: "Gender",
          gender_female: "Female",
          gender_male: "Male",
          street: "Street",
          address: "Address",
          suiteNumber: "Suite Number",
          city: "City",
          state: "State",
          zip: "Zip",
          phone: "Phone",
          fax: "Fax",
          email: "Email",
          facility: "Facility",
          planName: "{{coverageLevel}} Plan Name",
          planMarket: "{{coverageLevel}} Plan Market",
          memberId: "Member ID {{coverageLevel}}",
          groupId: "Group ID {{coverageLevel}}",
          ICD: "ICD",
          npi: "NPI",
          dea: "DEA",
          taxId: "TAX ID",
          seeDetails: "See Details",
          seeLess: "See Less",
          applicationCreated: "New application has been created",
          contactName: "Contact Name",
          contactEmail: "Contact Email",
          siteOfCareName: "Site of Care Name",
          RxCoverage: "Rx coverage",
          RxPayerName: "Payer Name",
          RxPlanMarket: "Plan Market",
          RxMemberId: "Member ID",
          RxGroup: "RxGRP",
          RxBIN: "RxBIN",
          RxPCN: "RxPCN"
        },
        required_message: "This is required"
      },
      all_statuses: "All Statuses",
      active_statuses: "Active Statuses",
      inactive_statuses: "Inactive Statuses",
      attachments: {
        wrong_file_type: `Attachment upload failed - Only {{fileTypes}} files are allowed,\nPlease try again.`,
        exceeds_total_file_size:
          "Attachment upload failed - The total size of all files should not exceed {{maxSize}} MB.",
        only_pdf_files: "Only PDF files are allowed.",
        exceeds_file_size: `Attachment upload failed - File size exceeds {{maxSize}} MB max,\nPlease try again.`,
        delete_modal: {
          cancel: "Back",
          submit: "Yes, I'm sure",
          title: "Delete Attachment",
          first_content: "You are about to delete an attachment.",
          second_content: "Are you sure this is what you want to do?"
        },
        upload_file: "Upload File",
        upload_pdf_file: "Upload PDF File",
        application_attachments: "Enrollment Attachments",
        internal_use_notice:
          "Files uploaded in this tab are for internal documentation only and are not sent as part of the Express Enroll submission.",
        format_requirements: "Format requirements:",
        must_be_pdf: "Must be a PDF",
        total_size_notice: "The total size of all files should not exceed {{maxSize}} ",
        no_attachments: "No attachments yet",
        upload: "Upload",
        delete: "Delete",
        uploaded_at: "Uploaded at",
        alt: {
          no_attachments: "No attachments yet"
        },
        error: {
          delete: "File delete failed",
          download: "File download failed",
          upload_generic: "File upload failed. Please try again.",
          upload_server: "File upload failed: {{errorMessage}}. Please try again.",
          cancel_request: "The E-Signature process failed to cancel the request",
          cancel_signature: "failed to cancel Signature",
          download_failed: "Download attachment failed"
        },
        success: {
          delete: "File has been successfully deleted",
          download: "File has been successfully downloaded",
          upload: "File upload successful.",
          cancel_request: "The E-Signature request was canceled successfully",
          cancel_signature: "The Signature was canceled successfully"
        },
        express_enroll: {
          no_attachments: {
            title: "Enrollment Attachments",
            sub_title:
              "Please add supporting attachments to the Enrollment Form (only PDF format). Relevant attachments are:",
            content_first_line: "- Copies of the front and back of the patient’s medical and pharmacy insurance cards",
            federal_tax_Return: "- Most recent federal tax return - page 1 of IRS 1040 form",
            w_two_form: "- W-2 Form",
            prescription_optional: "- Prescription",
            optional_attachments: " (optional)",
            tooltip_form_instruction: "link for more information:",
            prescription_tooltip:
              "<span>An e-signed enrollment form is <bold>not a valid prescription.</bold> In order for your patient to be considered for assistance, <bold>a valid prescription is required and must be submitted at the time of enrollment request</bold> in one of two ways:<br><br>Option 1: Submit a paper prescription with an ink signature, either by faxing it to 1-877-736-6506 or by attaching a scanned copy to the application.<br><br>Option 2: E-prescribe to AmeriPharm (NPI number–1073692745; NCPDP number–4351968) or MedVantx (NPI number–1235371535; NCPDP number– 4354180). <bold>New York prescribers must e-prescribe.</bold><span>",
            footer:
              "* If you do not have the documents now, you will have the opportunity to attach them to the Enrollment Form prior to submission.",
            eagle: {
              sub_title: "Please add supporting attachments to the enrollment (only pdf format).",
              sub_title_line_one: "Relevant attachments can include:",
              content_first_line: "- Copies of the front and back of patient’s medical insurance cards ",
              content_second_line: "- Copies of the front and back of patient’s pharmacy insurance cards "
            }
          }
        }
      },
      applications_in_hidden_programs: "Application/s exists in hidden programs",
      copy_paste_popover: {
        save_and_copy_to_clipboard: "Save & Copy To Clipboard",
        copy_to_clipboard: "Copy To Clipboard",
        popover_description:
          "Fill in the missing information and click copy. The information will be saved to your clipboard.",
        non_profit_Verification: "Non-Profit Verification",
        copay_assistance_cards_verification: "Co-pay Assistance Cards Verification",
        free_drug_assistance_verification: "Free-Drug Assistance Verification",
        fields: {
          medication_name: "Medication Name",
          name_of_non_profit: "Name of Non-Profit",
          copay_assistance_name: "Co-Pay Assistance Name",
          name_of_free_drug_program: "Name of Free Drug Program",
          phone_number: "Phone Number",
          non_profit_phone_number: "Non-Profit phone number",
          name_of_person_you_spoke_to: "Name of person you spoke to",
          verified_with: "Verified with",
          assistance_start_date: "Start date of the assistance",
          application_id: "Application ID",
          patient_id: "Patient ID",
          policy_number: "Policy Number",
          group: "Group #",
          group_number: "Group Number",
          bin: "BIN",
          pcn: "PCN",
          grant_amount: "Grant amount",
          patient_responsibility: "Patient Responsibility",
          grant_start_date: "Start date of Grant",
          grant_end_date: "Expiration of Grant",
          medication_listed_for_grant: "Medication listed for Grant",
          diagnosis_for_grant: "Diagnosis for Grant",
          member_id: "Member ID",
          approved_amount: "Approved Amount",
          max_benefit: "Max Benefit",
          approved_date: "Approved date",
          valid_through_date: "Valid through date",
          valid_through: "Valid through",
          additional_comments: "Additional Comments",
          out_of_pocket_amount: "Out of Pocket Amount",
          benefits_out_of_pocket_amount: "Benefits-Out of Pocket Amount",
          day_supply: "Day Supply",
          total_benefit_max: "Total benefit max",
          coverage_period: "Coverage Period"
        }
      },
      search_diagnosis: "Search diagnosis",
      select_assistance_type: "Select Assistance Type",
      search_diagnosis_error: "Error while searching diagnosis",
      track_tab: {
        notes: "Notes",
        add_a_new_note: "Add a new note",
        save_note: "Save Note",
        edit_note_placeholder: "Edit note",
        no_notes_yet: "No notes yet.",
        start_by_typing_in_the_box_above: "Start by typing in the box above.",
        delete_note: "Delete note",
        cancel: "Cancel",
        edit_note: "Edit note",
        enter_number: "Enter number",
        confirmation_button: "Yes, I'm sure",
        discard_changes: "Discard Changes",
        notes_section: {
          see_more: "See More",
          see_less: "See Less"
        },
        error_messages: {
          please_select_at_least_one_assistance_type: "Please select at least one assistance type",
          should_be_less_than_or_equal_to_number_of_characters:
            "Should be less than or equal to {{numberOfCharacters}} characters",
          should_be_less_than_or_equal_to_number_of_digits: "Should be less than or equal to {{numberOfDigits}} digits",
          only_letters_and_numbers_allowed: "Only letters and numbers are allowed",
          copay_card_length_error: "Should be 12-16 characters (excluding hyphens and spaces)",
          zip_code_format_error: "Should be a 5-digit number",
          bin_length_error: "Should be 6-8 characters",
          notes_length_error: "Maximum\ncharacter\nlimit\nreached",
          unsaved_changes: "Unsaved Changes",
          cvv_format_error: "Should be a 3-digit number",
          only_numbers_allowed: "Only numbers are allowed",

          billing_information_required:
            "At least one billing indicator is required when billing information is marked as available."
        },
        enrollment_details: "Enrollment Details",
        billing_information_available: "Billing information available",
        billing_information_instruction: "Turn this on if billing information is available for this enrollment.",
        billing_information_auto_populated:
          "This information was auto-populated from program data. Please verify and complete before saving.",
        billing_information_remove_modal: {
          title: "Remove Billing Information?",
          content: "Turning this off will remove all billing information for this enrollment",
          ok_text: "Turn off & Remove"
        }
      },
      last_saved: "Last saved {{updatedDate}} ",
      last_saved_by_user: "by {{user}}",
      unsaved_changes: "Unsaved Changes"
    },
    patient_communications: {
      header: "Send consent request to patient:",
      fpl_collection_text:
        "Please select if you would like to collect the below information from the patient in addition to requesting their consent",
      fpl_checkbox_label: "Request income & household size information",
      actions: {
        request: "Request"
      },
      fields: {
        email: "Email",
        sms: "SMS"
      },
      statuses: {
        completed: "Completed",
        pending: "Awaiting Response",
        expired: "Link Expired"
      },
      statuses_desc: {
        completed: "Signed by <span>{{name}}</span> on {{date}}",
        pending: "Request sent on {{date}}"
      },
      messages: {
        request_success: "Consent request was sent successfully",
        send_request_failed: "Failed to send consent request",
        get_request_failed: "Failed to get consent request"
      }
    },
    notifications: {
      label: "Notifications",
      title: {
        display: "Display",
        order_by: "Order by"
      },
      display_filter: {
        all_programs: "All Programs",
        open_with_relevant_patients: "Open with relevant patients",
        unread_notifications: "Unread notifications",
        recently_opened_programs: "Recently opened programs",
        closed_programs: "Closed programs"
      },
      order_sort: {
        date_new_to_old: "Date - new to old",
        date_old_to_new: "Date - old to new",
        status_open_to_close: "Status - open to close",
        unread_first: "Unread first"
      },
      program_value_and_moment: "Program {{value}}: {{moment}}",
      enrollment_closed: "Program enrollment period has closed",
      no_relevant_patients_waitlist_only: "Currently no relevant patients found that are applied to waitlist",
      no_relevant_patients: "Currently no relevant patients found",
      program_closed: "Program Closed",
      program_open: "Program Open",
      view_relevant_patients: "View Relevant Patients",
      get_notifications_failed: "Get notifications failed",
      marking_notifications_failed: "Marking notifications failed",
      mark_all_as_read: "Mark all as read",
      mark_all_as_read_failed: "Failed to mark all notifications as read",
      mark_all_as_unread: "Mark all as unread",
      mark_all_as_unread_failed: "Failed to mark all notifications as unread",
      settings: "Settings",
      relevant_patients_for: "Relevant patients for",
      back: "Back",
      mark_as_read: "Mark as read",
      mark_as_unread: "Mark as unread",
      results_unread: "{{results}} Results, {{unread}} Unread",
      tooltip: "Notifications",
      no_notifications: "You have no notifications."
    },
    top_opportunities: {
      relevant_patients_for_assistance_program_name: "Relevant patients for {{assistanceProgramName}}",
      back: "Back",
      program_status_time: "Program {{status}}: {{time}}",
      tm_patient: "TM-{{patientID}}",
      record_mrn: "MRN-{{mrnRecord}}",
      show_patients_from: "Show patients from",
      filter_strip: {
        all_assignees: "All Assignees",
        all_facilities: "All Facilities",
        all_physicians: "All Physicians",
        all_diagnoses: "All Diagnoses",
        all_diagnoses_codes: "All Diagnoses Codes",
        search_by_diagnosis_code: "Search by diagnosis code",
        search_by_diagnosis_name: "Search by diagnosis name",
        statuses: "Statuses",
        awaiting_assistance: "Awaiting Assistance"
      },
      failed_to_get_notification_data: "Failed to get notification data",
      received_corrupted_notification_data: "Received corrupted notification data",
      no_patients_found: "No Patients Found"
    },
    filter_list_view: {
      filter_list_top_section: {
        saved_lists: "Saved Lists",
        details: "Details",
        description: "From {{view}} • By {{user}}",
        unsaved_changes: "You have unsaved changes",
        save: "Save",
        last_modified_lbl: "Last update: "
      }
    },
    savedList: {
      search_placeholder: "Search by list name",
      no_list_name: "List",
      description: "From {{view}}",
      list_name_private_title: "Private List",
      list_name_private_sub_title: "Only visible to you",
      list_name_shared_title: "Shared List",
      list_name_shared_sub_title: "Visible to invited users",
      list_name_public_title: "Public List",
      list_name_public_sub_title: "Visible to all members of your org",
      list_name_starred_title: "Starred List",
      list_name_starred_sub_title: "Visible to you",
      copy_action: "The List link was successfully copied to your clipboard",
      copy_list_link: "Copy list link",
      sort_tooltip: "Sort",
      viewers: "Viewers",
      viewer: "Viewer",
      viewers_more: "... and {{count}} more",
      created_by: "Created By",
      last_update_lbl: "Last update: ",
      owner_in_valid_list: "This saved list is not available due to removed filters. Please delete and recreate.",
      non_owner_in_valid_list: "This saved list is not available due to removed filters - please recreate the list.",
      types_options: {
        all: "All",
        private: "Private",
        favorite: "Favorite",
        shared: "Shared"
      },
      actions_menu: {
        edit: "Edit List Info",
        copy: "Copy List Link",
        delete: "Delete",
        export: "Export List"
      },
      confirm_modal: {
        title: "Delete List",
        content:
          "Are you sure you want to delete ‘{{listName}}’ list? No one will be able to access this list anymore.",
        cancel_text: "Cancel",
        ok_text: "Yes, Delete",
        success_message: "List was successfully deleted",
        error_message: "Could not delete list"
      },
      discard_modal: {
        title: "Unsaved Changes",
        ok_text: "Yes, Discard",
        cancel_text: "Back",
        content: "Are you sure you want to discard the changes you made?"
      },
      show_number_of_records: "Show number of records",
      more_than_10000: "More than 10000 records",
      no_records: "No Records",
      get_number_of_records_failed: "Get number of patients failed!",
      sort_ascend_tooltip: "Click to sort ascending",
      sort_descend_tooltip: "Click to sort descending",
      sort_cancel_tooltip: "Click to cancel sorting"
    },
    contact_support: {
      title: "Contact Support",
      ticket_send_successfully: "Ticket was sent successfully",
      failed_to_send_ticket: "Failed to send message to support"
    },
    profile: {
      tooltip: "Profile and Settings"
    },
    calculator: {
      title: "Potential Savings Calculator",
      manufacturerTitle: "Manufacturer",
      manufacturerImport: "Input Manufacturer Name",
      drugNameTitle: "Drug Name & Package Type",
      drugNameInput: "Input Drug Name",
      packageSizeTitle: "Quantity / Package size",
      packageSizeQuantity: "Select quantity",
      packageNumberTitle: "Number of Packages",
      packageNumberInput: "Enter number",
      packageNumberTip: "Note - the number of packages will not affect the Pharmacy drug order",
      totalDrugPrice: "TOTAL DRUG PRICE",
      perPackage: "per package",
      input3Chars: "Please type at least 3 characters",
      loading_drug_information: "Loading drug information",
      total_price_error: "Total price cannot exceed 7 digits - please update the number of packages."
    },
    patient_statuses: {
      in_analysis: "In Analysis"
    },
    error_fallback: {
      title: "Unexpected Error",
      ok_text: "Go Back",
      p1: "Uh oh! Something went wrong on our end.",
      p2: "Click the button below to go back to the previous page."
    },
    express_enroll: {
      supports_express_enroll: "Supports Express Enrollment"
    },
    application_form_editor: ApplicationFormEditor,
    online_wizard: {
      title: "Online Wizard",
      subtitle: "An internal tool is used to preview and export EE forms.",
      unset_full_line_field_tooltip: "Click to unset field as full line.",
      set_full_line_field_tooltip: "Click to set field as full line.",
      json_export_pending_changes:
        "There are unsaved changes that will not be included in the exported JSON.\nDo you wish to continue exporting without these changes?",
      export: "Export",
      unsaved_changes: "Unsaved changes"
    },
    ai_chat_bot: {
      message_placeholder: "Message TeamMate AI",
      floating_message_placeholder: "Ask me a question",
      chat_bot_name: "TeamMate AI",
      chat_footer: "TeamMate AI can make mistakes. Consider checking important information.",
      new_chat: "New Chat",
      recent_conversations: "Recent",
      load_more: "Load More",
      open_chat_pages: "Open Chat Page",
      collapse_chat: "Collapse Chat",
      move_to_floating_chat: "Swich Chat Mode",
      move_to_floating_chat_streaming: "Available after streaming is complete",
      you_are_getting_early_look: "You're getting an early look at TeamMate AI! ",
      we_are_continuously_refining_and_expanding_its_capabilities:
        "We’re continuously refining and expanding its capabilities. Stay tuned for updates.",
      open_chat_pages_streaming: "Available after streaming is complete",
      errors: {
        failed_fetching_recent_conversations: "Failed to fetch recent conversations",
        failed_fetching_conversation_history: "Failed to fetch conversation history",
        failed_creating_conversation: "Failed to create new conversation",
        failed_fetching_suggested_questions: "Failed to fetch suggested questions",
        failed_processing_request: "Unfortunately we couldn’t process your request at this time. Try again later.",
        failed_submitting_feedback: "Failed to submit feedback"
      },
      intro_panel: {
        hello_message: "Hello {{firstName}}, ",
        how_can_i_help: "how can I help you today?",
        suggested: "SUGGESTED",
        failed_message_feedback_submission: "Failed to submit message feedback",
        failed_copying_message: "Failed to copy message",
        select_category: "Select the category that better fits your question to get started.",
        suggested_questions_card: {
          ask_a_new_question: "Ask a New Question",
          ask_questions_about: "Ask questions about {{theme}}. Examples:"
        }
      },
      message_actions: {
        copy_message: "Copy",
        like_message: "Good response",
        dislike_message: "Bad response"
      },
      feedback: {
        tell_me_more: "TELL US MORE",
        placeholder: "Briefly share why this response was unhelpful",
        send: "Send",
        thank_you_message: "Thank you! Your input is valuable and helps us make the chatbot better."
      }
    },
    edit_notes: {
      created_by: "Created by: {{user}} {{createdDate}}",
      updated_by: "Last updated by: {{user}} {{updatedDate}}",
      unsaved_changes: "Unsaved Changes",
      edit_popup: "You have unsaved application details",
      edit_popup_two: "Do you want to proceed?",
      created_on: "Created on: {{createdDate}}",
      maximum_character_limit_reached: " Maximum character limit reached",
      note_history_tooltip:
        "Created by: {{createdBy}} on {{createdDate}} \n Last updated by: {{updatedBy}} on {{updatedDate}}",
      note_history_tooltip_without_created_by:
        "Created on: {{createdDate}} \n Last updated by: {{updatedBy}} on {{updatedDate}}",
      note_created_tooltip: "Created by: {{createdBy}} on {{createdDate}}",
      note_modified_tooltip: "Last updated by: {{updatedBy}} on {{updatedDate}}",
      note_created_tooltip_no_update: "Created on: {{createdDate}}",
      create_note_error: "Create note failed",
      update_note_error: "Update note failed",
      delete_note_error: "Delete note failed",
      get_notes_error: "Get notes failed",
      add_note: "Type your note here",
      error_exceeds_character_limit: "Maximum character limit reached",
      patient_notes: "Patient Notes",
      save: "Save",
      cancel: "Cancel",
      edit_note: "Edit note",
      created_by_: "Created by",
      back: "Back",
      created: "Created",
      Last_updated_by: "Last updated by",
      last_updated: "Last updated",
      no_notes_yet: "No notes yet",
      start_by_typing_in_the_box_above: "Start by typing in the box above",
      you_have_unsaved_application_details: "You have unsaved application details",
      cancel_note: "Cancel",
      save_note: "Save Note",
      edit_your_note: "Edit your note...",
      delete: "Delete note",
      note_successfully_updated: "Note successfully updated",
      note_successfully_deleted: "Note successfully deleted",
      note_successfully_added: "Note successfully added",
      unsaved_changes_message:
        "You have unsaved changes in your note. Leaving the note will discard any unsaved changes.\n\nAre you sure you want to proceed?"
    },
    selfEnrollment: {
      invitation_sent_successfully: "Programs successfully shared with patient",
      invitation_send_failed: "Failed to send invitation",
      failed_to_load_invitation_history: "Failed to load invitation history",
      please_select_patient_first: "Please select a patient first",
      no_eligible_programs_for_self_enrollment: "No eligible self-enrollable programs found for patient.",
      invitation_sent_successfully_list: "Self-enrollment invitation sent successfully!",
      failed_to_generate_message_preview: "Failed to generate message preview",
      no_delivery_method_selected: "No delivery method selected",
      search_patient: "Search Patient",
      no_patient_selected: "No patient selected",
      no_patient_selected_description: "Please search and select a patient to send invitations",
      send_all_eligible_programs: "Send to Patient",
      send_specific_program: "Send Specific Program",
      invitation_types: "Invitation Types",
      invitation_history: "Invitation History",
      search_by_patient_name_or_id: "Search by patient name or ID",
      start_date: "Start Date",
      end_date: "End Date",
      failed_to_search_patients: "Failed to search patients",
      patient_name: "Patient Name",
      mrn: "MRN",
      patient_id: "Patient ID",
      contact: "Contact",
      action: "Action",
      search: "Search",
      select: "Select",
      no_patients_found: "No patients found",
      enter_patient_name_mrn_or_id: "Enter patient name, MRN, or ID to search",
      patient_name_and_id: "Patient Name and ID",
      date_last_sent: "Date Last Sent",
      patient_viewed: "Patient Viewed",
      application_created_by_patient: "Enrollment Created by Patient",
      date_created: "Date created",
      status: "Status",
      failed: "Failed",
      multiple_programs: "Multiple programs",
      unknown_program: "Unknown Program",
      first_last_name: "First Last Name",
      unknown_user: "Unknown User",
      yes: "Yes",
      no: "No",
      errors: {
        duplicate_phone_dob:
          "Self-enrollment invitation can not be sent. Multiple patients share the same phone number and date of birth. Please update the patient’s information.",
        missing_phone: "Cannot send self-enrollment invitation. Patient does not have a phone number on file.",
        missing_dob: "Cannot send self-enrollment invitation. Patient does not have a date of birth on file."
      },
      delivery_errors: {
        single_channel: {
          email: "Email invitation failed to send. Please check the email address and try again.",
          sms: "SMS invitation failed to send. Please check the phone number and try again."
        },
        all_channels_failed:
          "Failed to send invitation via all selected methods. Please check the contact information and try again."
      },
      send_all_eligible_programs_description:
        "Sends a general link for the patient to browse all their eligible assistance programs",
      send_specific_program_description: "Sends a deep link to a specific assistance program for direct enrollment",
      refresh: "Refresh",
      search_and_select_patient: "Search and Select Patient",
      search_by_patient_name_mrn_or_id: "Search by patient name, MRN, or ID...",
      dob: "DOB",
      unknown: "Unknown",
      last_sent_by: "Last Sent by",
      on: "on",
      no_invitations_sent_yet: "No invitations sent yet",
      submit_self_enroll_to: "Send Programs to",
      patients_can_use_patient_enroll:
        "Patients can use Patient Enroll to self-enroll in {{eligibleTypesText}} programs. All other program types must be completed by a Financial Navigator.",
      tip_even_if_send_one_program:
        "Tip: Even if you send just one program, the patient will still see every other program they can self-enroll in.",
      message_preview: "patient MESSAGE PREVIEW",
      missing_phone_number: "Missing Phone Number",
      missing_email_address: "Missing Email Address",
      missing_patient_phone_authentication:
        "Missing Patient Phone Number. It will be needed to authenticate the patient when logging in.",
      missing_patient_dob_authentication:
        "Missing Patient Date of Birth. DOB is used to authenticate the patient when logging in.",
      please_update_here: "Please update here.",
      patient_fallback: "Patient",
      unknown_program_fallback: "Unknown Program",
      program_xyz_placeholder: "Program XYZ Name, Program XYZ Name, Program XYZ Name",
      bridge_copay_default_types: "Bridge, Copay, Copay Foundation, and Quick Start",
      loading_message: "Loading message...",
      send_patient_enroll: "Send to Patient",
      invite_sent: "Invite sent",
      no_applications_found: "No applications found for this patient.",
      loading_invitation_history: "Loading invitation history...",
      no_invitation_history_found: "No invitation history found.",
      application_id: "Application ID:",
      sent_by: "Sent by:",
      no_eligible_programs_header: "No Eligible Programs",
      no_eligible_programs_message: "This patient has no eligible programs available for self-enrollment.",
      error_header: "Error",
      unable_to_load_preview: "Unable to load self-enrollment options. Please try again.",
      send_eligible_programs: "Send Eligible Programs",
      free_drug_sdoh_not_eligible: "Free Drug & SDOH are not eligible",
      programs_included: "Programs Included:",
      copay_card_programs: "Copay Card",
      manufacturer_programs: "Manufacturer Programs",
      copay_foundation_programs: "Copay Foundation",
      no_eligible_programs: "No eligible programs available",
      see_all_programs_that_will_be_shared: "See all programs that will be shared with the patient",
      programs_count: "{{eligible}} of {{total}} programs",
      program_name: "Program Name",
      application_created: "Enrollment Created",
      program_not_eligible_for_self_enroll: "This program is not eligible to send to patient for self enrollment.",
      program_has_existing_application_prepare:
        "Application in status prepare. This program cannot be sent to the patient.",
      program_has_existing_application_applied:
        "Patient Enroll isn’t available for this program. Please complete enrollment on the patient’s behalf.",
      program_has_existing_application_approved:
        "Application in status approved. This program cannot be sent to the patient.",
      program: "Program",
      type: "Type"
    },
    errorBoundary: {
      error_occurred: "An error occurred",
      error_description: "Something went wrong while rendering this component. Please try refreshing the page.",
      try_again: "Try Again"
    },
    pop_up_messages: {
      unsaved_changes: "Unsaved Changes",
      you_have_unsaved_changes_in_your_note:
        "You have unsaved changes in your note. Leaving the note will discard any unsaved changes. Are you sure you want to proceed?",
      you_have_unsaved_changes_in_your_form:
        "You have unsaved changes in your form. Leaving the form will discard any unsaved changes. Are you sure you want to proceed?"
    },
    consent: {
      title: "Consent",
      system: "System",
      effective_date: "Effective from",
      status: {
        no_record: "No consent on file",
        pending_signature: "Pending signature",
        consent_received: "Consent received",
        consent_revoked: "Consent revoked",
        link_revoked: "Link revoked",
        consent_expired: "Consent expired",
        request_link_expired: "Request link expired"
      },
      tooltips: {
        pending: "Sent by {{user}} on {{date}}",
        received: "{{user}} on {{date}}",
        revoked: "{{user}} on {{date}}",
        expired_by_system: "Automatically by system on {{date}}",
        expired_by_user: "{{user}} on {{date}}",
        link_expired: "Automatically by system on {{date}}",
        effective_date: "This is the date the consent status change takes effect.",
        revoke_disabled: "Consent cannot be revoked until one is registered.",
        action_not_allowed: "Log in with FN user to be able to use this feature"
      },
      drawer: {
        title: "Manage Consent for {{patientName}}",
        consent_history: "Consent History"
      },
      actions: {
        request_consent: "Request consent",
        register_consent: "Record consent",
        revoke_consent: "Revoke consent",
        manage_consent: "Manage Consent"
      },
      forms: {
        consent_via_label: "How was consent {{actionType}}?",
        consent_via_placeholder: "Select Here",
        date_label: "Effective date",
        attachments_title: "Attachments",
        field_required: "{{fieldName}} is required",
        patient_fallback: "Patient",
        attachment_filename: "ThisisTheFileName.PDF",
        action_replace: "Replace",
        action_remove: "Remove",
        details_label: "Details",
        details_placeholder_collect: "Add any notes about how consent was collected.",
        details_placeholder_revoke: "Add any notes about how consent was revoked.",
        cancel_button: "Cancel",
        save_button: "Save",
        upload_failed: "Upload failed",
        fix_file_error: "Please fix the file error before saving",
        upload_file: "Upload File",
        size_limit: "Size limit {{maxSize}}MB",
        loading_states: {
          requesting: "Requesting",
          saving: "Saving"
        },
        action_types: {
          received: "Recorded",
          revoked: "Revoked",
          requested: "Requested"
        },
        request: {
          message_preview_title: "MESSAGE PREVIEW",
          preview_button: "Preview as Patient",
          request_button: "Request",
          cancel_button: "Cancel",
          dob_error_message:
            "Patient date of birth required. Date of birth is required to verify the patient's identity when signing consent.",
          contact_error_message: "Missing Patient contact information.",
          dob_and_contact_error_message:
            "Missing Patient Date of Birth and contact information. DOB is used to authenticate the patient when signing.",
          add_missing_details_action:
            "Please add the DOB in <ManagePatientDetailsLink>Manage Patient Details</ManagePatientDetailsLink> and try again.",
          message_template:
            "Hello {{patientName}}, this is {{fnName}} from {{siteName}}. To review and enroll you in financial support programs that may help with your expenses, I need your consent to use your information. Please read and sign the consent form here the link. Let me know if you have any questions. ",
          fpl_checkbox_label: "Request income & household size information",
          error_all_channels_failed: "Failed to send consent request.",
          error_email_failed: "Failed to send consent request through patient email.",
          error_sms_failed: "Failed to send consent request through patient phone number.",
          partial_success_email_failed:
            "Partial success. Consent request sent to phone number. Email delivery failed- please check the address and retry.",
          partial_success_sms_failed:
            "Partial success. Consent request sent to email. Phone number delivery failed- please check the number and retry.",
          add_email_placeholder: "Add Email",
          add_phone_placeholder: "Add Phone Number"
        },
        via_options: {
          phone: "by phone",
          email: "by email",
          in_person: "in person",
          econsent_link: "electronically",
          other: "other"
        },
        error_messages: {
          received: "There was an error registering consent.",
          revoked: "There was an error revoking consent."
        },
        success_messages: {
          request: "Consent requested successfully.",
          register: "Consent recorded successfully.",
          revoke: "Consent revoked successfully."
        }
      },
      history: {
        no_record: "No general consent on file",
        request_sent: "Consent request sent",
        consent_received: "Consent documented (manual)",
        electronic_consent_received: "Consent signed (digital)",
        electronic_consent_subtitle_prefix: "Signed by patient",
        consent_revoked: "Consent revoked",
        link_revoked: "Request link revoked",
        link_expired: "Link automatic expiration",
        consent_expired: "Consent expired"
      },
      alerts: {
        electronic_consent_disabled:
          "Your site doesn't have the functionality of digitally request consent, you can still manually register it."
      },
      download: {
        downloading: "Downloading...",
        click_to_download: "Click to download {{fileName}}",
        download_file: "Download File",
        failed: "Download failed."
      },
      error: {
        loading_history: "Error loading consent history.",
        retry: "Retry"
      },
      unsaved_changes: {
        title: "You have unsaved changes",
        message:
          "If you leave this page, your changes to consent details will be lost. Are you sure you want to continue",
        stay_button: "Stay on page",
        discard_button: "Discard changes"
      }
    },
    notification_preferences: {
      page_title: "Notifications",
      page_description:
        "Customize your notifications to stay informed about what matters most. Choose which updates you'd like to receive and manage your preferences anytime.",
      open_funds_title: "Open Funds",
      open_funds_description: "Toggle notifications for all funds.",
      global_section_title: "Global Notifications",
      global_section_description: "Enable or disable all assistance program notifications",
      global_toggle_label: "Receive all assistance program notifications",
      global_enabled_description: "You will receive notifications for all assistance programs",
      global_disabled_description: "You will not receive any assistance program notifications",
      advanced_settings_title: "Advanced Foundation Notification Settings",
      search_description: "Looking for a specific foundation or fund? Search for it here.",
      search_placeholder: "Search for foundation or specific fund name",
      search_no_results: "No results found",
      search_clear: "Clear search",
      in_app_label: "In App",
      email_label: "Email",
      status_subscribed_all: "Subscribed to all",
      status_subscribed: "Subscribed",
      status_partially_subscribed: "Partially subscribed",
      status_partially_subscribed_with_exclusions: "{{enabled}}/{{total}} enabled ({{excluded}} excluded)",
      status_unsubscribed: "Unsubscribed",
      status_excluded: "Excluded",
      no_search_results: "No results found",
      no_search_results_description: "Try adjusting your search terms or clearing the search to see all options.",
      no_funds_found: "No funds found",
      try_searching_again: "Try searching again.",
      foundation_section_title: "Foundation Notifications",
      foundation_section_description: "Customize notifications by foundation",
      foundation_toggle_all: "All {{foundationName}} programs",
      foundation_programs_count: "{{count}} program",
      foundation_programs_count_plural: "{{count}} programs",
      foundation_partially_enabled: "Some programs enabled",
      foundation_all_enabled: "All programs enabled",
      foundation_all_disabled: "No programs enabled",
      fund_section_title: "Individual Programs",
      fund_excluded_note: "This program is excluded from {{foundationName}} notifications",
      fund_enabled_note: "This program is included in {{foundationName}} notifications",
      fund_standalone_program: "Standalone program",
      state_enabled: "Enabled",
      state_disabled: "Disabled",
      state_excluded: "Excluded",
      state_loading: "Loading...",
      state_saving: "Saving...",
      state_error: "Error",
      message_load_success: "Notification preferences loaded successfully",
      message_load_error: "Failed to load notification preferences",
      message_fetch_error: "Failed to fetch notification preferences",
      message_update_success: "Notification preference updated",
      message_update_error: "Failed to update notification preference",
      message_network_error: "Network error occurred. Please try again.",
      message_validation_error: "Invalid preference data",
      message_save_failed_reverting: "Save failed. Reverting changes...",
      tooltip_global_disabled: "Global notifications are disabled",
      tooltip_foundation_disabled: "Foundation notifications are disabled",
      tooltip_excluded_program: "This program is excluded from foundation notifications",
      tooltip_auto_save: "Changes are saved automatically",
      tooltip_indeterminate_state: "Some programs in this foundation are enabled",
      accessibility_toggle_global: "Toggle global notifications",
      accessibility_toggle_foundation: "Toggle notifications for {{foundationName}}",
      accessibility_toggle_program: "Toggle notifications for {{programName}}",
      accessibility_search_input: "Search foundations and programs",
      accessibility_back_button: "Go back to settings"
    },
    settings: {
      my_preferences_title: "My Preferences",
      my_preferences_subtitle: "Personalize how the platform connects with you.",
      notification_settings_title: "Notifications",
      notification_settings_description: "Add/Remove notifications for specific programs and actions",
      portal_credentials_title: "Portal Credentials",
      portal_credentials_description: "Manage your credentials for financial assistance portal sites",
      shared_site_settings_title: "Shared Site Settings",
      shared_site_settings_subtitle: "Update shared settings for everyone at your site.",
      physicians_title: "Physicians",
      physicians_description: "View, add, or edit physician records for your organization",
      automatic_rules_title: "Automatic Rules",
      automatic_rules_description: "Configure automatic sending rules for patient communications"
    },
    portal_credentials: {
      page_title: "Portal Credentials",
      page_subtitle:
        "Manage your saved credentials for financial assistance portal sites. These credentials are securely encrypted and used for automated enrollment processes.",
      add_credential: "Add Credential",
      edit_credential: "Edit Credential",
      no_credentials: "No portal credentials configured yet.",
      no_credentials_description: "Add your first portal credential to enable automated enrollment processes.",
      portal_name: "Portal",
      username: "Username",
      password: "Password",
      status: "Status",
      last_updated: "Last Updated",
      actions: "Actions",
      valid: "Valid",
      invalid: "Invalid - Please Update",
      save: "Save",
      delete: "Delete",
      confirm_delete: "Are you sure you want to delete this credential?",
      confirm_delete_description:
        "This action cannot be undone. The credential for {{portalName}} will be permanently removed.",
      save_success: "Credential saved successfully",
      delete_success: "Credential deleted successfully",
      error_loading: "Failed to load portal credentials",
      error_saving: "Failed to save credential",
      error_deleting: "Failed to delete credential",
      form_portal_label: "Select Portal",
      form_portal_placeholder: "Select a portal",
      form_username_label: "Username",
      form_username_placeholder: "Enter your portal username",
      form_password_label: "Password",
      form_password_placeholder: "Enter your portal password",
      validation_portal_required: "Please select a portal",
      validation_username_required: "Please enter your username",
      validation_password_required: "Please enter your password",
      form_password_update_hint: "Enter a new password to update",
      security_note: "Your credentials are encrypted using industry-standard encryption and stored securely.",
      invalid_reason: "Reason: {{reason}}",
      invalid_at: "Marked invalid on {{date}}",
      disclaimer_default:
        "By storing your credentials, you authorize TailorMed to securely access these portals on your behalf to submit and manage financial assistance applications for your patients."
    },
    physician_management: {
      breadcrumb: {
        settings: "Settings",
        physicians: "Physicians",
        new_physician: "New Physician",
        physician_detail: "Physician Detail"
      },
      list: {
        page_title: "All Physicians",
        page_description: "View, add, or edit physician records for your organization.",
        show_inactive: "Show Inactive Physicians",
        search_placeholder: "Type to search physicians...",
        export: "Export",
        add_physician: "Add Physician",
        empty_state_title: "No physicians added yet.",
        empty_state_description: "Get started by adding your first physician.",
        empty_state_bulk_upload_text: "If you'd like to bulk upload, please",
        empty_state_contact_support: "contact support",
        empty_state_bulk_upload_suffix: "to share your file.",
        search_empty_title: "No physicians found.",
        search_empty_description: "Missing someone? Add them now.",
        no_active_physicians_title: "No active physicians added yet.",
        no_active_physicians_description: "Check the 'Show inactive' filter to view inactive physicians.",
        name_id: "Name / NPI",
        facility: "FACILITY",
        address: "ADDRESS",
        phone_number: "PHONE NUMBER",
        email: "EMAIL",
        active: "ACTIVE",
        active_status: "ACTIVE",
        inactive_status: "INACTIVE",
        edit_tooltip: "Click to edit",
        view_tooltip: "View details",
        total_physicians: "Total physicians:",
        pagination_showing: "Showing: {{range_start}}-{{range_end}} of {{total}}",
        physicians_label: "Physicians",
        no_update_information: "No update information",
        csv_header_id: "id",
        csv_header_active: "active",
        csv_header_name: "name",
        csv_header_title: "title",
        csv_header_facility: "facility",
        csv_header_phone: "phone",
        csv_header_fax: "fax",
        csv_header_address: "address",
        csv_header_suite: "suite",
        csv_header_city: "city",
        csv_header_state: "state",
        csv_header_zip: "zipCode",
        csv_header_npi: "npi",
        csv_header_email: "email",
        csv_header_ptan: "ptan",
        csv_header_dea: "dea",
        csv_header_license: "stateLicense",
        csv_header_taxid: "taxId",
        csv_header_signature: "signatureFileName",
        csv_header_created_at: "createdAt",
        csv_header_created_by: "createdBy",
        csv_header_updated_at: "updatedAt",
        csv_header_updated_by: "updatedBy",
        export_success: "Physician list downloaded successfully.",
        export_error: "Failed to export physician list. Please try again."
      },
      form: {
        section_main: "Main Information",
        section_practice: "Practice Location",
        section_contact: "Contact Information",
        section_personal: "Personal Information",
        label_npi: "NPI",
        label_first_name: "First Name",
        label_last_name: "Last Name",
        label_title: "Title",
        label_address: "Office Street Address",
        label_suite: "Suite",
        label_facility: "Facility",
        label_city: "City",
        label_state: "State",
        label_zip: "Zip Code",
        label_phone: "Phone Number",
        label_fax: "Fax Number",
        label_email: "Email",
        label_state_license: "State License",
        label_ptan: "PTAN",
        label_dea: "DEA",
        label_tax_id: "Tax ID",
        placeholder_npi: "10-digit NPI number",
        placeholder_first_name: "Enter first name",
        placeholder_last_name: "Enter last name",
        placeholder_title: "Enter title",
        placeholder_address: "Enter street address",
        placeholder_suite: "Enter suite number",
        placeholder_facility: "Enter facility name",
        placeholder_city: "Enter city",
        placeholder_state: "Select state",
        placeholder_zip: "Enter zip code",
        placeholder_email: "Enter email address",
        placeholder_state_license: "Enter state license number",
        placeholder_ptan: "Enter PTAN number",
        placeholder_dea: "Enter DEA number",
        placeholder_tax_id: "Enter tax ID",
        validation_npi_required: "NPI is required",
        validation_npi_format: "NPI must be valid",
        validation_first_name_required: "First name is required",
        validation_last_name_required: "Last name is required",
        validation_email_invalid: "Please enter a valid email address",
        validation_alphanumeric: "Please enter only letters and numbers",
        validation_alphanumeric_no_spaces: "Please enter only letters and numbers (no spaces)",
        validation_zip_format: "Please enter a valid 5-digit zip code",
        duplicate_warning_partial:
          "A physician with this NPI already exists in the system. If this is a different location, continue and add the address. Click to view duplicates.",
        duplicate_warning_exact:
          "A physician with this NPI and address already exists in the system. Click to view duplicates.",
        duplicate_table_npi: "NPI",
        duplicate_table_name: "Name",
        duplicate_table_address: "Address",
        duplicate_table_status: "Status",
        duplicate_table_last_updated: "Last Updated",
        duplicate_table_created: "Created",
        duplicate_table_view: "View",
        success_created: "Physician profile created successfully",
        success_updated: "Physician profile updated successfully",
        phone_pattern: "(000) 000-0000",
        phone_enter_digits: "Please enter 10 digits."
      },
      form_page: {
        button_save: "Save",
        button_saving: "Saving",
        button_cancel: "Cancel",
        status_active: "ACTIVE",
        status_inactive: "INACTIVE"
      },
      detail: {
        button_edit: "Edit",
        label_npi: "NPI",
        label_name: "Full Name",
        label_title: "Title",
        label_address: "Office Street Address",
        label_suite: "Suite",
        label_facility: "Facility",
        label_city: "City",
        label_state: "State",
        label_zip: "Zip Code",
        label_phone: "Phone Number",
        label_fax: "Fax Number",
        label_email: "Email",
        label_state_license: "State License",
        label_ptan: "PTAN",
        label_dea: "DEA",
        label_tax_id: "Tax ID",
        default_title: "Doctor",
        created_by: "Created on {{date}} by {{user}}",
        updated_by: "Last Updated on {{date}} by {{user}}",
        default_user: "User"
      },
      modal: {
        add_title: "Add New Physician",
        edit_title: "Edit Physician",
        unsaved_title: "You Have Unsaved Changes",
        unsaved_message:
          "You have unsaved changes in your form. Leaving the form will discard any unsaved changes. Are you sure you want to proceed?",
        ok_text_add: "Add Physician",
        ok_text_save: "Save Changes",
        ok_text_discard: "Discard Changes",
        cancel_text_stay: "Continue Editing",
        cancel_text: "Cancel"
      }
    },
    export: {
      button_text: "Export",
      loading_text: "Exporting",
      button_label: "Export list",
      csv_option: "CSV",
      xlsx_option: "XLSX",
      downloadStarted: "Your download has started.",
      preparing_export: "Exporting in Progress",
      record_limit_exceeded_tooltip:
        "Export is limited to {{limit}} records. Please apply more filters to reduce the list size.",
      modal_title: "Confirm Export",
      modal_summary:
        "You are about to export your current view containing <strong>{{count}}</strong> records as a {{fileType}} file.",
      subtitle: "Security Disclaimer:",
      modal_phi_warning_text:
        "<strong>{{subtitle}}</strong> This file may contain Protected Health Information (PHI). By downloading, you confirm you will handle this data securely and in accordance with your organization's policies.",
      modal_confirm_button: "Confirm",
      default_list_type: "records",
      success_message: "Your download has started.",
      error_message: "Could not prepare your export. Please try again."
    },
    bulk_actions: {
      selected_label: "selected",
      select_all: "Select all",
      select_first: "Select first {{count}}",
      current_user_suffix: "(Me)",
      record: "record",
      record_plural: "records",
      actions: {
        status: "Status",
        facility: "Facility",
        physician: "Physician",
        assignee: "Assignee"
      },
      dropdown: {
        confirm: "Confirm",
        cancel: "Cancel",
        no_matching_facilities: "No matching facilities",
        no_matching_physicians: "No matching physicians",
        no_matching_assignees: "No matching assignees"
      },
      assignee_mode: {
        add: "Add",
        remove: "Remove",
        override: "Override",
        override_tooltip: "Override existing assignees",
        add_tooltip: "Add to existing assignees",
        remove_tooltip: "Remove from existing assignees"
      },
      loading: {
        inline_message: "Bulk action in progress • Stay on this page",
        global_toast_message: "Bulk action in progress."
      },
      results: {
        success_message: "Bulk update complete. {{count}} {{entity}} updated.",
        partial_message: "{{succeeded}} of {{total}} records were updated. Try again on refreshed results.",
        failure_message: "Bulk update failed. Try again.",
        download_report: "Download Report"
      },
      report: {
        file_name: "bulk_action_report_{{timestamp}}",
        column_id: "Record ID",
        column_status: "Status",
        column_error: "Error Message",
        status_success: "Success",
        status_failed: "Failed",
        header_title: "Bulk Action Report",
        header_entity: "Record Type",
        header_action: "Action",
        header_new_value: "New Value",
        header_total_records: "Total Records",
        header_succeeded: "Succeeded",
        header_failed: "Failed",
        action_update_status: "Update Status",
        action_update_facility: "Update Facility",
        action_update_physician: "Update Physician",
        action_update_assignee_set: "Update Assignee (Set)",
        action_update_assignee_add: "Update Assignee (Add)",
        action_update_assignee_remove: "Update Assignee (Remove)",
        entity_patient: "Patient",
        entity_enrollment: "Enrollment",
        entity_claim: "Claim",
        entity_order: "Order",
        value_none: "None",
        value_na: "N/A"
      },
      errors: {
        generic: "An error occurred while processing the bulk action."
      }
    }
  }
};
